<template>
  <div id="salesQuery-tree-grid" class="grid-view">
    <div class="main-content">
      <search-item
        :ref="searchItemConfigModule"
        :config-module="searchItemConfigModule"
        :is-collapse-list="true"
        :grid-options="gridOptions"
        :grid-config-module="'23150100'"
        :is-append-query="true"
        :reset="true"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        source-page="sales"
        :lob="sopStateLob"
        :custom-search-items="customSearchItems"
        :hidden-search-item-filter="hiddenSearchItemFilter"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
        @sopStateCallBack="sopStateChange"
        @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
      >
        <div slot="operations">
          <!--查看-->
          <el-button no="1" :disabled="!selectedJob || total <= 0" type="success" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
          <!--统计-->
          <el-button no="2" type="primary" @click="statistics_clickHandler()">{{ $t('SeaExport.Statistics') }}</el-button>
          <!--新增/编辑/删除/费用导入-->
          <el-dropdown
            v-show="showOperateMultiJobChargeBtn"
            no="chargeHandle"
            split-button
            type="primary"
            :disabled="!validMultipleSelect"
            style="margin:0 5px"
            @click="chargeHandle"
            @command="p=>{chargeCommand=p;chargeHandle()}"
          >
            {{ chargeCommand }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="item in operateMultiJobChargeBtns" :key="item" :command="item">
                {{ item }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!--打印-->
          <el-dropdown
            v-if="$checkPermission(['button_SalesQueryModule_salesPrint'])"
            no="3"
            :disabled="!btnInfo.batchSelectFlag || !validMultipleSelect"
            split-button
            type="primary"
            @click="onBatchPrint($t('SeaExport.BatchPrint'))"
            @command="onBatchPrint"
          >
            {{ $t('SeaExport.BatchPrint') }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('queryJob.PrintByBusinessNumber')">{{ $t('queryJob.PrintByBusinessNumber') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown
            no="3"
            :disabled="!validMultipleSelect"
            style="margin:0 5px;font-size: 12px"
            @command="batchHandle"
          >
            <el-button type="primary" :disabled="!btnInfo.batchSelectFlag || !validMultipleSelect">
              {{ $t('SeaExport.BatchProcessing') }}
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="$checkPermission(['button_JobBooking_BatchFillGpExplain'])" :command="1">{{ $t('SeaExport.BatchFillGpExplain') }}</el-dropdown-item>
              <el-dropdown-item :command="2" :disabled="!$checkPermission(['button_Charge_BatchUnlockPayable'])">{{ $t('SeaExport.BatchUnlockPayableFees') }}</el-dropdown-item>
              <el-dropdown-item :command="3" :disabled="!$checkPermission(['button_Charge_BatchLockPayable'])">{{ $t('SeaExport.BatchLockingPayableFees') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button v-permission="['button_SMPartner_releaseApplication']" type="primary" @click="releaseApplicationDialog.visible = true">{{ $t('CargoMsg.Cargo_TemporaryDocumentReleaseApplication') }}</el-button>
          <!-- 申请解锁（费用解锁线上审批） -->
          <el-button
            v-if="$checkPermission(['button_ledger'])"
            no="unlockApply"
            type="primary"
            style="margin-left: 5px"
            @click="toUnlockApply"
          >{{ $t('SeaExport.UnlockApplyBtn') }}</el-button>
        </div>
      </search-item>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid
          config-module="23150100"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="finalColumnDefs"
          :pre-column-state-callback="preColumnStateCallback"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          :enable-col-resize="true"
          :enable-sorting="true"
          :check-main-record="false"
          :deselect-main-record="false"
          :has-export-role="!isSalesForSzfs"
          class="ag-theme-balham"
          style="width: 100%;"
          @gridReady="onGridReady"
          @columnRowGroupChanged="() => { this.$refs[searchItemConfigModule].clickCollapseList() }"
        />
      </div>
      <div class="pagination-wrapper amount-sum">
        <div class="amount-sum-right">
          <el-button class="amount-sum-btn" type="text" @click="openChargeStatDialog">合计详情</el-button>
        </div>
        <div class="amount-sum-left">
          <label style="margin-right: 5px;" />
          <span v-show="$checkPermission(['role_SalesQueryModule_income']) && !showSalePriceHc">
            {{ $t('CargoMsg.Cargo_TotalRevenue') + ' ：  ' + incomeTotalText }}
          </span>
          <label style="margin-right: 35px;" />
          <span v-show="$checkPermission(['role_SalesQueryModule_profit']) && !showSalePriceHc">
            {{ $t('CargoMsg.Cargo_TotalProfit') + '  ：  ' + profitTotalText }}
          </span>
          <label style="margin-right: 20px;" />
          <span>
            {{ $t('CargoMsg.Cargo_TicketCount') + '  ：  ' + ticketCount }}
          </span>
          <label style="margin-right: 20px;" />
          <span>
            {{ $t('CargoMsg.Cargo_CartonQuantity') + '  ：  ' + cartonQuantity }}
          </span>
          <label style="margin-right: 20px;" />
          <span>
            {{ '应收费用利息 ：  ' + costInterestTotalText }}
          </span>
        </div>
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="!appendQuery"
          config-module="23150100"
          :total="total"
          :page-count="pageCount"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery()"
        />
        <div v-show="appendQuery" class="pagination-container">
          <el-pagination
            style="text-align: left;"
            :total="total"
            layout="total"
          />
        </div>
      </div>
    </div>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :job-uuid-list="jobUuidList"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 统计弹窗 -->
    <el-dialog
      v-if="statisticsDialog.visible"
      v-el-drag-dialog
      :visible.sync="statisticsDialog.visible"
      :title="$t('SeaExport.Statistics')"
      :width="$selectByLang('360px', '445px')"
      :close-on-click-modal="false"
    >
      <el-form :label-width="$selectByLang('85px', '170px')" label-position="left">
        <el-form-item :label="$t('SeaExport.Slaves')" class="custom">
          <el-input v-model="statisticsDialog.txtSlaves" no="4" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Master')" class="custom">
          <el-input v-model="statisticsDialog.txtMaster" no="5" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.TotalTickets')" class="custom">
          <el-input v-model="statisticsDialog.txtCount" no="6" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CustomerCount')" class="custom">
          <el-input v-model="statisticsDialog.txtCustomerCount" no="7" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="20＇" class="custom">
          <el-input v-model="statisticsDialog.txt20" no="8" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="40＇" class="custom">
          <el-input v-model="statisticsDialog.txt40" no="9" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="40HQ＇" class="custom">
          <el-input v-model="statisticsDialog.txt40hq" no="10" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="45＇" class="custom">
          <el-input v-model="statisticsDialog.txt45" no="11" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label="TEU" class="custom">
          <el-input v-model="statisticsDialog.txtTeu" no="12" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Weight2')" class="custom">
          <el-input v-model="statisticsDialog.txtWeight" no="13" style="width:160px" :disabled="true" />
          <span>KGS</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Cubage')" class="custom">
          <el-input v-model="statisticsDialog.txtCubage" no="14" style="width:160px" :disabled="true" />
          <span>CBM</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ChargedWeight')" class="custom">
          <el-input v-model="statisticsDialog.txtChargeWeight" no="15" style="width:160px" :disabled="true" />
          <span>M/T</span>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.SpecifyAgentNumber')" class="custom">
          <el-input v-model="statisticsDialog.txtdesignationAgentNum" no="16" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label-width="0" class="custom">
          <el-checkbox v-model="statisticsDialog.containShutOutJob" no="17" @change="handleStatistics(true)">{{ $t('SeaExport.ContainShutOutJob') }}</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="statisticsDialog.visible = false">{{ $t('SeaExport.Close') }}</el-button>
      </div>
    </el-dialog>
    <!-- 合计详情弹窗 -->
    <el-dialog
      v-if="chargeStatDialog.visible"
      v-el-drag-dialog
      :visible.sync="chargeStatDialog.visible"
      title="合计详情"
      custom-class="charge-stat-dialog"
      width="420px"
      :close-on-click-modal="false"
    >
      <div v-if="chargeStatDialog.currencies.length" class="charge-stat-table">
        <div class="charge-stat-row charge-stat-head">
          <div class="charge-stat-cell label">币种</div>
          <div v-for="currency in chargeStatDialog.currencies" :key="currency" class="charge-stat-cell">{{ currency }}</div>
        </div>
        <div v-for="row in chargeStatRows" :key="row.key" class="charge-stat-row">
          <div class="charge-stat-cell label">{{ row.label }}</div>
          <div v-for="currency in chargeStatDialog.currencies" :key="currency" class="charge-stat-cell">
            {{ formatStatAmount(row.values[currency]) }}
          </div>
        </div>
      </div>
      <div v-else class="charge-stat-empty">暂无数据</div>
      <div slot="footer">
        <el-button @click="chargeStatDialog.visible = false">{{ $t('SeaExport.Close') }}</el-button>
      </div>
    </el-dialog>
    <!-- GP说明-->
    <add-gp-explain-dialog
      v-if="gpExplain.visible"
      :type="gpExplain.type"
      :visible.sync="gpExplain.visible"
      :job-uuids="gpExplain.jobUuids"
    />
    <!-- 应收应付类型选择弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="chargeTypeDialog.visible"
      :title="chargeTypeDialog.title"
      width="500px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div style="margin: 30px 30px;">
        <el-radio-group v-model="chargeTypeDialog.type" size="small">
          <el-radio v-for="option in chargeTypeDialog.data" :key="option.label" :label="option.label" style="width: 100px">{{ option.name }}</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="onChargeTypeDialogConfirm">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="chargeTypeDialog.visible = false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 新增费用弹窗 -->
    <add-charge-detail-dialog
      v-if="addChargeDetailDialog.visible"
      :visible.sync="addChargeDetailDialog.visible"
      :selected-jobs="addChargeDetailDialog.selectedJobs"
      :charge-type="addChargeDetailDialog.chargeType"
      :selected-scheme="addChargeDetailDialog.selectedScheme"
      :lob="lobWithFba"
      :location="location"
      @toChangeSchema="toChangeSchema"
    />
    <!-- 新增特殊费用弹窗 -->
    <special-charge-window
      :visible.sync="specialChargeWindow.visible"
      :default-properties="specialChargeWindow.defaultProperties"
      :location="location"
    />
    <!-- 编辑费用/特殊费用弹窗 -->
    <edit-charge-detail-dialog
      v-if="editChargeDetailDialog.visible"
      :visible.sync="editChargeDetailDialog.visible"
      :selected-jobs="editChargeDetailDialog.selectedJobs"
      :charge-type="editChargeDetailDialog.chargeType"
      :modify-special-charge="editChargeDetailDialog.modifySpecialCharge"
      :lob="lobWithFba"
    />
    <!-- 删除费用弹窗 -->
    <delete-charge-detail-dialog
      v-if="deleteChargeDetailDialog.visible"
      :visible.sync="deleteChargeDetailDialog.visible"
      :selected-jobs="deleteChargeDetailDialog.selectedJobs"
      :charge-type="deleteChargeDetailDialog.chargeType"
      :lob="lobWithFba"
    />
    <!-- 费用解锁申请弹窗 -->
    <unlock-apply-dialog
      v-if="unlockApplyDialog.visible"
      :visible.sync="unlockApplyDialog.visible"
      :selected-jobs="unlockApplyDialog.selectedJobs"
      @success="toQuery"
    />
    <!-- 费用导入弹窗 -->
    <charge-scheme-batch-dialog
      v-if="chargeSchemeBatchDialog.visible"
      :visible.sync="chargeSchemeBatchDialog.visible"
      :selected-jobs="chargeSchemeBatchDialog.selectedJobs"
      :charge-type="chargeSchemeBatchDialog.chargeType"
      :job="chargeSchemeBatchDialog.job"
      :need-check-range="chargeSchemeBatchDialog.needCheckRange"
      :lob="chargeSchemeBatchDialog.lob"
      :is-sea="chargeSchemeBatchDialog.isSea"
      :original-condition="chargeSchemeBatchDialog.originalCondition"
      :charge-scheme-is-approved="chargeSchemeBatchDialog.chargeSchemeIsApproved"
      :location="location"
      :source="chargeSchemeBatchDialog.source"
      @selectedSchemeHandler="handleSelectedScheme"
    />

    <!-- 放单申请弹窗 -->
    <release-application-dialog :visible.sync="releaseApplicationDialog.visible" type="document" />
  </div>
</template>

<script>
import addChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/addChargeDetailDialog'
import specialChargeWindow from '@/components/Cargo/Job/specialChargeWindow'
import editChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/editChargeDetailDialog'
import DeleteChargeDetailDialog from '@/views/cargo/v0/SeaExport/components/booking/deleteChargeDetailDialog.vue'
import ChargeSchemeBatchDialog from '@/views/cargo/v0/SeaExport/components/booking/chargeSchemeBatchDialog'
import { Charge } from '@/class/model/act/Charge'
import { resolveSalesSpecialChargeBranchId } from '@/components/Cargo/Job/booking/tabs/specialChargeDefaults'
import LocalStorageUtils from '@/utils/localStorageUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { Job } from '@/class/model/booking/Job'
import { BATCH_PRINT_SE, BATCH_PRINT_SI, BATCH_PRINT_AE, BATCH_PRINT_AI, BATCH_PRINT_RE, BATCH_PRINT_IE } from '@/class/cargo/model/parameters/DocumentConstants'
import { buildBatchPrintDialogPayload } from '@/views/cargo/v0/Sales/components/salesQuery/salesQueryBatchPrint'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { DocumentManage, stopBubble } from '@/utils/commonUtil'
import jobDetailIcon from '@/assets/job-detail.png'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import { stringToBool } from '@/utils/commonUtil'
import { statisticsJobs } from '@/api/seaExport/seaExportJob'
import { batchModifyChargeLockStatus, findJobForSales } from '@/api/booking/job'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { cacheName, cache } from '@/utils/cacheManager'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { formatNumberToThousands } from '@/utils'
import DateUtils from '@/utils/dateUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { OPERATOR_EQUAL, OPERATOR_GREATER_EQUAL, OPERATOR_LESS_EQUAL, OPERATOR_LIKE } from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import BookingTreeGridMixin from '@/mixin/BookingTreeGridMixin'
import AddGpExplainDialog from '@/components/Cargo/Job/addGpExplainDialog.vue'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { getUserPrivileges } from '@/api/auth'
import {
  CHARGE_TYPE_RADIO_COST_PAY, CHARGE_TYPE_RADIO_COST_PAY_SPECIAL,
  CHARGE_TYPE_RADIO_PAY,
  LOG_AE_AIR_BOOKING, LOG_AI_AIR_BOOKING, LOG_RE_RAILWAY_BOOKING,
  LOG_SE_SEA_BOOKING,
  LOG_SI_SEA_BOOKING
} from '@/class/cargo/model/parameters/SystemConstants'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import ReleaseApplicationDialog from '@/views/cargo/v0/Information/components/partner/tab/releaseApplicationDialog.vue'
import UnlockApplyDialog from '@/views/cargo/v0/SeaExport/components/booking/unlockApplyDialog'

export default {
  name: 'SalesQueryTreeGrid',
  components: {
    ReleaseApplicationDialog,
    UnlockApplyDialog,
    addChargeDetailDialog, specialChargeWindow, editChargeDetailDialog, DeleteChargeDetailDialog, ChargeSchemeBatchDialog,
    AddGpExplainDialog,
    CargoAdvanceSelect,
    CargoGridShowBigContent,
    searchItem,
    cargoTemplateSelectorDialog
  },
  mixins: [BookingTreeGridMixin],
  props: {
    context: {
      type: Object,
      required: true
    },
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    return {
      addChargeDetailDialog: {
        visible: false,
        chargeType: SystemConstants.CHARGE_TYPE_RADIO_COST_PAY.code,
        selectedScheme: [],
        selectedJobs: []
      },
      specialChargeWindow: {
        visible: false,
        defaultProperties: {} // 特殊费用调整默认条件
      },
      editChargeDetailDialog: {
        visible: false,
        selectedJobs: [],
        chargeType: SystemConstants.CHARGE_TYPE_RADIO_COST_PAY.code,
        modifySpecialCharge: false
      },
      deleteChargeDetailDialog: {
        visible: false,
        selectedJobs: [],
        chargeType: SystemConstants.CHARGE_TYPE_RADIO_COST_PAY.code
      },
      unlockApplyDialog: {
        visible: false,
        selectedJobs: []
      },
      chargeSchemeBatchDialog: {
        visible: false,
        selectedJobs: [],
        chargeType: SystemConstants.CHARGE_TYPE_RADIO_COST_PAY.code,
        originalCondition: {},
        isSea: false,
        needCheckRange: true,
        lob: '',
        source: 'jobList',
        chargeSchemeIsApproved: false // 费用方案需是否审核后才能使用【费用方案页签使用】
      },
      chargeTypeDialog: {
        visible: false,
        type: -1,
        title: '',
        data: []
      },
      chargeTypes: {},
      operateMultiJobChargeBtns: [], // 批量操作业务费用 按钮下拉取值
      showOperateMultiJobChargeBtn: false, // 批量操作业务费用 按钮是否展示
      chargeCommand: '', // 批量操作业务费用 按钮当前值
      currentChargeType: '', // 当前选择的费用类型，用于费用方案选择后传递
      arSettlementUnitOptional: false,
      specialExpenseEntryFunction: false,
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      customSearchItems: [], // 自定义高级查询项
      inputIncludingTaxUnitPrice: 0,
      checkJobTypeHasDiff: false, // 是否验证业务类型
      salesCanSeeBookingAgent: false,
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      filterJson: {},
      total: 0,
      pageCount: 0,
      selectedJob: null,
      gridParams: {},
      perConfigName: '',
      gridRefreshId: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('queryJob.businessNumber'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              return true
            },
            innerRenderer: params => {
              const methodPath = this.documentManage.getPath('showBusinessInfo')
              // 费用解锁申请状态标记：0=解锁审批中 1=解锁中（空不显示）
              return `<span>${params.value}<img src="${jobDetailIcon}" height="16" width="16" style="vertical-align: sub;margin-left:3px;cursor:pointer" onclick="${methodPath}(event)"/></span>` + ColumnUtils.unlockApplyStatusTag(params.data.unlockApplyStatus)
            }
          }
        },
        onRowDataChanged: event => {
          this.$refs[this.searchItemConfigModule].clickCollapseList()
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.onGridRowSelected(event)
        },
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: event => { this.toLook(event.data) },
        getRowStyle: (params) => {
          const row = params.data
          const { colorSettings, colorType } = this
          if (colorType) {
            return JobUtils.financeColor(row)
          } else if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
            Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
            JobUtils.isBlockJob(row)) {
            return { 'background': colorSettings.find(item => item.colorKey === 'isBlocked').colorValue }
          } else {
            const jobState = String(row.jobState) || ''
            for (const stateColor of colorSettings) {
              if (jobState === stateColor.colorKey) {
                return { 'background': stateColor.colorValue }
              }
            }
          }
          return {}
        },
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnAdds: [],
      rowData: [],
      gridApi: null,
      gridColumnApi: null,
      isLastCompanyCC: undefined,
      showControlledProfit: false,
      documentManage: new DocumentManage(),
      templateSelectorDialog: {
        visible: false,
        ctx: new Job(),
        category: '',
        data: {}
      },
      jobUuidList: [],
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      statisticsDialog: { // 统计
        visible: false,
        txtSlaves: 0,
        txtMaster: 0,
        txtCount: 0,
        txtCustomerCount: 0,
        txt20: 0,
        txt40: 0,
        txt40hq: 0,
        txt45: 0,
        txtTeu: 0,
        txtWeight: 0.000,
        txtChargeWeight: 0.000,
        txtCubage: 0.000,
        txtdesignationAgentNum: 0,
        containShutOutJob: false
      },
      btnInfo: {
        batchSelectFlag: false // 批量操作
      },
      gpExplain: {
        type: 'list',
        visible: false,
        jobUuids: []
      },
      chargeStatDialog: {
        visible: false,
        currencies: [],
        receivable: {},
        due: {},
        total: {}
      },
      appendQuery: false, // 追加查询
      profitTotalText: '', // 利润总计
      incomeTotalText: '', // 收入总计
      costInterestTotalText: '', // 应收费用利息总计
      cartonQuantity: '', // 箱型箱量总计
      ticketCount: 0, // 票数
      initProfitTotalText: '', // 初始利润总计
      initIncomeTotalText: '', // 初始收入总计
      initCostInterestTotalText: '', // 初始应收费用利息总计
      initCartonQuantity: '', // 初始箱型箱量总计
      initTicketCount: 0, // 初始票数
      showSalePriceHc: false, // 显示销售单价hc权限：有此权限时隐藏金额相关字段，在created中异步赋值
      sopStateLob: 'SE', // 业务状态追踪对应的业务类型
      defaultSearchItems: [],
      elementDict: {},
      releaseApplicationDialog: {
        visible: false
      }
    }
  },
  computed: {
    chargeStatRows() {
      return [
        { key: 'receivable', label: '应收(费用)', values: this.chargeStatDialog.receivable || {}},
        { key: 'due', label: '应付(费用)', values: this.chargeStatDialog.due || {}},
        { key: 'total', label: '合计', values: this.chargeStatDialog.total || {}}
      ]
    },
    lobWithFba() {
      if (this.gridApi) {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length > 0) {
          return rows[0].fba ? ('FBA_' + rows[0].lob) : rows[0].lob
        }
      }
      return ''
    },
    location() {
      if (this.gridApi) {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length > 0 && !rows[0].fba) {
          switch (rows[0].lob) {
            case 'SE':
              return LOG_SE_SEA_BOOKING.code
            case 'SI':
              return LOG_SI_SEA_BOOKING.code
            case 'AE':
              return LOG_AE_AIR_BOOKING.code
            case 'AI':
              return LOG_AI_AIR_BOOKING.code
            case 'RE':
            case 'RI':
              return LOG_RE_RAILWAY_BOOKING.code
            default:
          }
        }
      }
      return ''
    },
    searchItemConfigModule() {
      return '231501'
    },
    bookingAgentVisible() {
      return SalesUtil.salesCanBookingAgent(this.salesCanSeeBookingAgent)
    },
    columnDefs() {
      const result = [ // 显示列
        {
          headerName: this.$t('CargoMsg.Cargo_Carrier'),
          field: 'carrierId',
          colId: 'carrierId',
          cellRenderer: (params) => {
            return ColumnUtils.carrierLabelFunc(params.data, params.data.carrierId)
          },
          width: 200,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.carrierLabelFunc(params.data, params.data.carrierId)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_TruckingCompany'),
          colId: 'carryingCmp',
          field: 'carryingCmp',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_11') : ''
          },
          hide: false,
          width: 200,
          filterParams: {},
          filterValueGetter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.carryingCmp, 'auto_11')
          }
        }, {
          headerName: this.$t('SeaExport.Vessel'),
          field: 'vessel',
          colId: 'vessel',
          width: 150
        }, {
          headerName: this.$t('SeaExport.Voyage'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          width: 150
        }, {
          headerName: this.$t('SeaExport.Customer'),
          colId: 'customerId',
          field: 'customerId',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
          },
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessDate'),
          field: 'businessDate',
          colId: 'businessDate',
          cellRenderer: (params) => {
            return DateUtils.formatStandardDate(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContractStatus'),
          colId: 'contractStatus',
          field: 'contractStatus',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_RiskReason'),
          colId: 'riskReason',
          field: 'riskReason',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
          colId: 'loadingPortCode',
          field: 'loadingPortCode',
          cellRenderer: (params) => {
            return ColumnUtils.getPortLabel('code', params.value, params.data, 'auto_7')
          },
          width: 170,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getPortLabel('code', params.data.loadingPortCode, params.data, 'auto_7')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          colId: 'destinationPortCode',
          field: 'destinationPortCode',
          cellRenderer: (params) => {
            return ColumnUtils.getPortLabel('code', params.value, params.data, 'auto_7')
          },
          width: 150,
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getPortLabel('code', params.data.destinationPortCode, params.data, 'auto_7')
          }
        }, {
          headerName: this.$t('SeaExport.FinancialExamineDate'),
          field: 'financialExamineDate',
          cellRenderer: (params) => {
            return params.value || ''
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture'),
          field: 'etd',
          colId: 'etd',
          cellRenderer: (params) => {
            return DateUtils.formatStandardDate(params.value)
          },
          width: 150
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          colId: 'remarks',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SpecialPriceInstructions'),
          field: 'salePriceRemarks',
          colId: 'salePriceRemarks',
          hide: true,
          width: 150
        },
        { headerName: this.$t('SeaExport.CustomerService'), field: 'csr', hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }, width: 100 },
        { headerName: this.$t('SeaExport.CustomerService'), field: 'csr', hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }, width: 100 },
        { headerName: this.$t('AirExport.AeMawbChargeWeight'), field: 'aeMawbCWeight', width: 180, colId: 'aeMawbCWeight', hide: true,
          cellRenderer: (params) => {
            if (params.data && !params.data.masterFlag && params.data.operateType === AirExportConstants.CONSOLE.code) {
              return '0.000'
            }
            return ColumnUtils.numberColumnLabelFunc(params.value, 3)
          }
        },
        { headerName: this.$t('AirExport.AeBookingChargeWeight'), field: 'aeChargeWeightBooking', width: 180, colId: 'aeChargeWeightBooking', hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 3)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SettlementType'), field: 'settlementType', width: 100, hide: true
        },
        { headerName: this.$t('CargoMsg.Cargo_AccountPeriod'), field: 'creditDateLimited', width: 100, hide: true
        },
        {
          headerName: this.$t('SeaExport.TradeTerms2'),
          field: 'incoTerm',
          hide: true,
          width: 180,
          enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_IsExtended'), field: 'creditInfoDateExceeded', width: 100, hide: true,
          cellRenderer: params => {
            if (params.value === '') return ''
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          filterParams: {},
          filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
        },
        { headerName: this.$t('CargoMsg.Cargo_ExcessiveOrNot'), field: 'creditInfoAmountExceeded', width: 100, hide: true,
          cellRenderer: params => {
            if (params.value === '') return ''
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          filterParams: {},
          filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CompanyDateOfCreation'),
          field: 'companyCreateDate',
          colId: 'companyCreateDate',
          hide: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CargosExpectedArrivalDatePacking'),
          field: 'loadingDate',
          colId: 'loadingDate',
          hide: true,
          width: 150,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }
      ]
      if (this.bookingAgentVisible && !this.isSalesForSzfs) {
        result.push({
          headerName: this.$t('CargoMsg.Cargo_BookingWindow'),
          field: 'bookingAgent',
          colId: 'bookingAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1') : ''
          },
          width: 200
        })
      }

      if (!this.isSalesForSzfs) {
        result.push({
          headerName: this.$t('queryJob.destinationAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_2') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          colId: 'designationAgent',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_3') : ''
          },
          width: 200
        }, {
          headerName: this.$t('queryJob.mblNo'),
          field: 'mbl',
          colId: 'mbl',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.mblLabelFunc(params.value, params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.mblLabelFunc(params.data.mbl, params.data)
          }
        }, {
          headerName: this.$t('SeaExport.ShippingCompanyContractNo'),
          field: 'scNo',
          colId: 'scNo',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.InnerContractNo'),
          field: 'contractNo',
          colId: 'contractNo',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomJobType'),
          field: 'customJobType',
          colId: 'customJobType',
          cellRenderer: (params) => {
            return ColumnUtils.customJobTypeLabelFunc(params.value)
          },
          hide: true,
          width: 150
        })
      }

      result.push({
        headerName: this.$t('SeaExport.ItemNo'),
        field: 'poNo',
        colId: 'poNo',
        width: 150
      }, {
        headerName: this.$t('SeaExport.Operation'),
        field: 'op',
        colId: 'op',
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.Sales'),
        field: 'sales',
        colId: 'sales',
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_sales')
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.SalesDepartment'),
        field: 'salesDepartment',
        colId: 'salesDepartment',
        width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
        }
      },
      { headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'overseaOp', width: 180, colId: 'overseaOp',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      },
      {
        headerName: '海外跟单',
        field: 'userDefinedRoleId4',
        colId: 'userDefinedRoleId4',
        width: 140,
        enableRowGroup: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      {
        headerName: this.$t('SeaExport.Status'),
        field: 'jobState',
        colId: 'jobState',
        cellRenderer: (params) => {
          return ColumnUtils.getJobStateForBlock(params.data)
        },
        filterParams: {},
        filterValueGetter: (params) => {
          return ColumnUtils.getJobStateForBlock(params.data)
        },
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_BusinessType'),
        field: 'lob',
        colId: 'lob',
        cellRenderer: (params) => {
          return ColumnUtils.jobBussStateLabelFunc(params.value)
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.ShutOut'),
        colId: 'shutOut',
        enableRowGroup: true,
        hide: true,
        valueGetter: (params) => {
          if (!params.data) return undefined
          const d = params.data
          return d.isShutOut !== undefined && d.isShutOut !== null ? d.isShutOut : d.shutOut
        },
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        },
        filterParams: {},
        filterValueGetter: (params) => {
          if (!params.data) return ''
          const d = params.data
          const v = d.isShutOut !== undefined && d.isShutOut !== null ? d.isShutOut : d.shutOut
          return ColumnUtils.booleanLabelFunction(stringToBool(v))
        },
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_ActualChargedWeight'),
        field: 'chargeWeight',
        colId: 'chargeWeight',
        cellRenderer: (params) => {
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.CommissionedNumberOfPackages'),
        field: 'quantityContract',
        colId: 'quantityContract',
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value)
        },
        width: 150
      },
      {
        headerName: this.$t('CargoMsg.Cargo_PrePortBusinessLeader'),
        field: 'prePortPlanner',
        colId: 'prePortPlanner',
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value || 0), 'chineseName')
        }
      },
      {
        headerName: this.$t('SeaExport.AirlinePerson2'),
        field: 'planner',
        colId: 'planner',
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value || 0), 'chineseName')
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_LastMileBusinessLeader'),
        field: 'lastMilePlanner',
        colId: 'lastMilePlanner',
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value || 0), 'chineseName')
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_preportAuditStatus'),
        field: 'prePortApproveStatus',
        colId: 'prePortApproveStatus',
        enableRowGroup: true,
        valueGetter: (params) => {
          return ColumnUtils.priceJobStateLabelFunc(params.data.prePortPlanner, Number(params.data.prePortApproveStatus))
        },
        filterParams: {},
        filterValueGetter: (params) => {
          return ColumnUtils.priceJobStateLabelFunc(params.data.prePortPlanner, Number(params.data.prePortApproveStatus))
        },
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_TrunkLineAuditStatus'),
        field: 'trunkLineApproveStatus',
        colId: 'trunkLineApproveStatus',
        enableRowGroup: true,
        valueGetter: (params) => {
          return ColumnUtils.priceJobStateLabelFunc(params.data.planner, Number(params.data.trunkLineApproveStatus))
        },
        filterParams: {},
        filterValueGetter: (params) => {
          return ColumnUtils.priceJobStateLabelFunc(params.data.planner, Number(params.data.trunkLineApproveStatus))
        },
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_TailEndAuditStatus'),
        field: 'lastMileApproveStatus',
        colId: 'lastMileApproveStatus',
        enableRowGroup: true,
        valueGetter: (params) => {
          return ColumnUtils.priceJobStateLabelFunc(params.data.lastMilePlanner, Number(params.data.lastMileApproveStatus))
        },
        filterParams: {},
        filterValueGetter: (params) => {
          return ColumnUtils.priceJobStateLabelFunc(params.data.lastMilePlanner, Number(params.data.lastMileApproveStatus))
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.ContainerNo'),
        field: 'containerNos',
        colId: 'containerNos',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ContainerDescription'),
        field: 'containerDesc',
        colId: 'containerDesc',
        hide: true,
        cellRenderer: (params) => {
          const curJob = params.data
          if (curJob && curJob.lclMasterUuid && curJob.containerLoadType === 'BCF') {
            return ''
          }
          return ColumnUtils.containerDescLabelFunc(params.value)
        },
        width: 150,
        filterParams: {},
        filterValueGetter: (params) => {
          const curJob = params.data
          if (curJob && curJob.lclMasterUuid && curJob.containerLoadType === 'BCF') {
            return ''
          }
          return ColumnUtils.containerDescLabelFunc(curJob.containerDesc)
        }
      }, {
        headerName: this.$t('SeaExport.CommissionedGrossWeight'),
        field: 'weightContract',
        colId: 'weightContract',
        cellRenderer: (params) => {
          if (!params.value) params.value = ''
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.CommissionedVolume'),
        field: 'cubageContract',
        colId: 'cubageContract',
        cellRenderer: (params) => {
          if (!params.value) params.value = ''
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.ActualQuantity'),
        field: 'quantityActual',
        colId: 'quantityActual',
        cellRenderer: (params) => {
          if (!params.value) params.value = ''
          return ColumnUtils.numberColumnLabelFunc(params.value)
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.ActualWeight'),
        field: 'weightActual',
        colId: 'weightActual',
        cellRenderer: (params) => {
          if (!params.value) params.value = ''
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.ActualVolume'),
        field: 'cubageActual',
        colId: 'cubageActual',
        cellRenderer: (params) => {
          if (!params.value) params.value = ''
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        },
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_PayablesWriteOfStatus'),
        colId: 'due',
        field: 'due',
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_ReceivablesWriteOfStatus'),
        colId: 'receivable',
        field: 'receivable',
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_ReceivableFullWriteOffTime'),
        colId: 'allReceivableClearingDate',
        field: 'allReceivableClearingDate',
        cellRenderer: (params) => {
          return DateUtils.formatStandardDate(params.value)
        },
        width: 160
      }, {
        headerName: this.$t('CargoMsg.Cargo_BuyingPrice'),
        colId: 'buying',
        field: 'buying',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_SellingPrice'),
        colId: 'selling',
        field: 'selling',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_ArrivalDate'),
        field: 'eta',
        colId: 'eta',
        cellRenderer: (params) => {
          return DateUtils.formatStandardDate(params.value)
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.FinalDestination'),
        field: 'destinationPlace',
        colId: 'destinationPlace',
        width: 150
      }, {
        headerName: this.$t('SeaExport.LocalService'),
        field: 'loadingTerm',
        colId: 'loadingTerm',
        cellRenderer: (params) => {
          return ColumnUtils.loadingTermNewLabelFunction(params.data, params.value)
        },
        hide: true,
        width: 150,
        filterParams: {},
        filterValueGetter: (params) => {
          return ColumnUtils.loadingTermNewLabelFunction(params.data, params.data.loadingTerm)
        }
      }, {
        headerName: this.$t('SeaExport.DateOfCreation'),
        field: 'dateCreated',
        colId: 'dateCreated',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.BusinessReferenceNo'),
        field: 'customerRefNo',
        colId: 'customerRefNo',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.DeliveryDate'),
        field: 'destPortDeliveryTime',
        colId: 'destPortDeliveryTime',
        width: 150,
        cellRenderer: (params) => {
          return DateUtils.formatStandardDate(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.quotationNum'),
        field: 'quotationNum',
        colId: 'quotationNum',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('queryJob.route'),
        colId: 'transportLine',
        field: 'transportLine',
        hide: true,
        width: 180,
        valueFormatter: (params) => {
          return ColumnUtils.routeLabelFunction(params.data)
        },
        filterParams: {},
        filterValueGetter: (params) => {
          return ColumnUtils.routeLabelFunction(params.data)
        }
      }, {
        headerName: 'TEU',
        colId: 'teu',
        field: 'teu',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.UserDefinedField1'),
        field: 'userDefinedField1',
        colId: 'userDefinedField1',
        width: 180,
        valueFormatter: params => {
          return params.value
        }
      }, {
        headerName: this.$t('SeaExport.UserDefinedField2'),
        field: 'userDefinedField2',
        colId: 'userDefinedField2',
        width: 180,
        valueFormatter: params => {
          return params.value
        }
      }, {
        headerName: this.$t('SeaExport.UserDefinedField3'),
        field: 'userDefinedField3',
        colId: 'userDefinedField3',
        width: 180,
        valueFormatter: params => {
          return params.value
        }
      }, {
        headerName: this.$t('SeaExport.UserDefinedField4'),
        field: 'userDefinedField4',
        colId: 'userDefinedField4',
        width: 180,
        valueFormatter: params => {
          return params.value
        }
      }, {
        headerName: this.$t('SeaExport.SalesOfGoods'),
        colId: 'cargoSalesId',
        field: 'cargoSalesId',
        hide: true,
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_sales')
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.OperationDate'),
        field: 'customsDate',
        colId: 'customsDate',
        width: 180,
        valueFormatter: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.ActualDateOfDeparture2'),
        field: 'atd',
        colId: 'atd',
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.ActualDateOfArrival2'),
        field: 'ata',
        colId: 'ata',
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.EstimatedPortArrivalTime'),
        field: 'estimatedArrivalTime',
        colId: 'estimatedArrivalTime',
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        },
        width: 150
      }, {
        headerName: this.$t('SeaExport.Consignee'),
        colId: 'consigneeLine1',
        field: 'consigneeLine1',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.Shipper'),
        colId: 'shipperLine1',
        field: 'shipperLine1',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('CargoMsg.Cargo_khPlateNumber'),
        field: 'khPlateNumber',
        colId: 'khPlateNumber',
        width: 120,
        hide: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_khTrailerNumber'),
        field: 'khTrailerNumber',
        colId: 'khTrailerNumber',
        width: 120,
        hide: true
      }, {
        headerName: this.$t('Invoice.invoice_receivablesInvoicingStatus'),
        colId: 'receivableInvoiceState',
        field: 'receivableInvoiceState',
        width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
        },
        hide: true
      }, {
        headerName: this.$t('Invoice.invoice_payablesInvoicingStatus'),
        colId: 'payableInvoiceState',
        field: 'payableInvoiceState',
        width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
        },
        hide: true
      }, {
        headerName: this.$t('SeaExport.CustomerContactPerson'),
        field: 'customerContact',
        colId: 'customerContact',
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.SOPStatus'),
        field: 'sopState',
        colId: 'sopState',
        width: 100,
        tooltipValueGetter: (params) => params.value
      }, {
        headerName: this.$t('CargoMsg.Cargo_SopTemplateName'),
        field: 'trackingTemplateUuid',
        width: 180,
        colId: 'trackingTemplateUuid',
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TrackingTemplate, 'uuid', params.value, 'templateName')
        }
      }, {
        headerName: this.$t('SeaExport.CargoType'),
        field: 'cargoType',
        colId: 'cargoType',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.MasterBLFreightTerm'),
        field: 'paymentTermMBL',
        colId: 'paymentTermMBL',
        hide: true,
        width: 150,
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.paymentTermLabelFunc(params.data.paymentTermMBL)
          }
          return ''
        }
      }, {
        headerName: this.$t('SeaExport.HBLFreightClause'),
        field: 'paymentTermHBL',
        colId: 'paymentTermHBL',
        hide: true,
        width: 150,
        valueGetter: (params) => {
          if (params.data) {
            return ColumnUtils.paymentTermLabelFunc(params.data.paymentTermHBL)
          }
          return ''
        }
      }, {
        headerName: this.$t('SeaExport.ActualLiftingDate'),
        field: 'actualPickUpTime',
        colId: 'actualPickUpTime',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.ActualReturnTime'),
        field: 'destPortReturnTime',
        colId: 'destPortReturnTime',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.Hbl2'),
        field: 'hblNb2',
        colId: 'hblNb2',
        width: 120,
        hide: true
      }, {
        headerName: this.$t('SeaExport.CustomerLevel'),
        field: 'customerTypeId',
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', params.value, 'chineseName')
        },
        width: 150,
        hide: true
      }, {
        headerName: this.$t('SeaExport.ActualDeliveryToCustomersWarehouseTime'),
        field: 'deliveryCompletionDate',
        colId: 'deliveryCompletionDate',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateMinutesLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('Message.Customer_Service'),
        colId: 'csrDepartment',
        field: 'csrDepartment',
        width: 180,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('Message.Documentation_Department'),
        colId: 'dcDepartment',
        field: 'dcDepartment',
        width: 180,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_ReceivableChargeInput'),
        field: 'receivableChargeInput',
        colId: 'receivableChargeInput',
        width: 200,
        filter: false,
        filterParams: {},
        valueFormatter: (params) => {
          return ColumnUtils.chargeInputLabelFunction(params.value)
        },
        hide: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_CostChargeInput'),
        field: 'costChargeInput',
        colId: 'costChargeInput',
        width: 200,
        filter: false,
        filterParams: {},
        valueFormatter: (params) => {
          return ColumnUtils.chargeInputLabelFunction(params.value)
        },
        hide: true
      }, {
        headerName: this.$t('SeaExport.branchLineDateOfDeparture'),
        field: 'seBargeEtd',
        colId: 'seBargeEtd',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.branchLineDateOfArrival'),
        field: 'seBargeEta',
        colId: 'seBargeEta',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_bargeEtd'),
        field: 'ieBargeEtd',
        colId: 'ieBargeEtd',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_bargeAtd'),
        field: 'ieBargeAtd',
        colId: 'ieBargeAtd',
        hide: true,
        width: 150,
        valueFormatter: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.Marks'),
        field: 'mark',
        colId: 'mark',
        initialWidth: 100,
        hide: true
      }, {
        headerName: this.$t('SeaExport.ApproachDate'),
        colId: 'approachDate',
        field: 'approachDate',
        cellRenderer: (params) => {
          return DateUtils.formatStandardDateTime(params.value)
        },
        width: 120,
        hide: true
      }, {
        headerName: this.$t('SeaExport.SolicitationType'),
        field: 'cargoSource',
        colId: 'cargoSource',
        cellRenderer: (params) => {
          return ColumnUtils.cargoSourceLabelFunction(params.value)
        },
        hide: true,
        width: 150
      }, {
        headerName: this.$t('SeaExport.ReceivableChargeLockedStatus'),
        field: 'receivableChargeLockedStatus',
        colId: 'receivableChargeLockedStatus',
        hide: true,
        width: 150,
        cellRenderer: (params) => {
          return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
        }
      }, {
        headerName: this.$t('SeaExport.PayableChargeLockedStatus'),
        field: 'payableChargeLockedStatus',
        colId: 'payableChargeLockedStatus',
        hide: true,
        width: 150,
        cellRenderer: (params) => {
          return ColumnUtils.chargeLockedStatusLabelFunc(Number(params.value))
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_PayableFeeLockTime'),
        field: 'payableChargeLockedDate',
        colId: 'payableChargeLockedDate',
        hide: true,
        width: 150,
        cellRenderer: (params) => {
          return DateUtils.formatStandardDateTime(params.value)
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_PayableFeeLockPerson'),
        field: 'payableChargeLockedPerson',
        colId: 'payableChargeLockedPerson',
        hide: true,
        width: 150,
        valueGetter: (params) => {
          return ColumnUtils.getPayableChargeLockedPerson(params.data)
        }
      }, {
        // TASK#236 公司CC时查询条件和设置列隐藏超期利息、应收费用利息字段
        headerName: this.$t('CargoMsg.Cargo_InterestAmountCurrency'),
        colId: 'interestAmountCurrency',
        field: 'interestAmountCurrency',
        width: 140,
        hide: true,
        suppressColumnsToolPanel: this.isCompanyCC,
        enableRowGroup: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_Accrued'),
        field: 'provisioned',
        colId: 'provisioned',
        width: 100,
        hide: true,
        cellRenderer: params => {
          if (params.value === '') return ''
          return ColumnUtils.booleanLabelFunction(params.value)
        },
        filterParams: {},
        filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
      }, {
        headerName: this.$t('CargoMsg.Cargo_SalesProvision'),
        field: 'salesProvision',
        colId: 'salesProvision',
        width: 100,
        hide: true,
        cellRenderer: params => {
          if (params.value === '') return ''
          return ColumnUtils.booleanLabelFunction(params.value)
        },
        filterParams: {},
        filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
      }, {
        headerName: this.$t('CargoMsg.Cargo_CustomerServiceProvision'),
        field: 'csProvision',
        colId: 'csProvision',
        width: 120,
        hide: true,
        cellRenderer: params => {
          if (params.value === '') return ''
          return ColumnUtils.booleanLabelFunction(params.value)
        },
        filterParams: {},
        filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
      }, {
        headerName: this.$t('CargoMsg.Cargo_OperationProvision'),
        field: 'opProvision',
        colId: 'opProvision',
        width: 120,
        hide: true,
        cellRenderer: params => {
          if (params.value === '') return ''
          return ColumnUtils.booleanLabelFunction(params.value)
        },
        filterParams: {},
        filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
      }, {
        headerName: this.$t('CargoMsg.Cargo_CustomsProvision'),
        field: 'customsProvision',
        colId: 'customsProvision',
        width: 120,
        hide: true,
        cellRenderer: params => {
          if (params.value === '') return ''
          return ColumnUtils.booleanLabelFunction(params.value)
        },
        filterParams: {},
        filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
      }, {
        headerName: this.$t('CargoMsg.Cargo_BusinessProvision'),
        field: 'businessProvision',
        colId: 'businessProvision',
        width: 120,
        hide: true,
        cellRenderer: params => {
          if (params.value === '') return ''
          return ColumnUtils.booleanLabelFunction(params.value)
        },
        filterParams: {},
        filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
      }, {
        headerName: this.$t('CargoMsg.Cargo_SalesSupervisorProvision'),
        field: 'salesSupervisorProvision',
        colId: 'salesSupervisorProvision',
        width: 120,
        hide: true,
        cellRenderer: params => {
          if (params.value === '') return ''
          return ColumnUtils.booleanLabelFunction(params.value)
        },
        filterParams: {},
        filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
      }, {
        headerName: this.$t('CargoMsg.Cargo_OperationSupervisorProvision'),
        field: 'opSupervisorProvision',
        colId: 'opSupervisorProvision',
        width: 120,
        hide: true,
        cellRenderer: params => {
          if (params.value === '') return ''
          return ColumnUtils.booleanLabelFunction(params.value)
        },
        filterParams: {},
        filterValueGetter: params => ColumnUtils.booleanLabelFunction(params.value)
      }, {
        headerName: this.$t('CargoMsg.Cargo_AccrualDate'),
        field: 'provisionedDate',
        colId: 'provisionedDate',
        width: 150,
        hide: true,
        cellRenderer: (params) => {
          return DateUtils.formatStandardDate(params.value)
        }
      }
      )
      return result
    },
    finalColumnDefs() {
      let result = [...this.columnDefs, ...this.columnAdds]
      // TASK#236 公司CC时动态控制应收费用利息列显隐与设置列可见性（columnAdds在created时一次性取值，不随公司切换更新）
      result = result.map(item => {
        if (item && item.colId === 'costInterest') {
          return { ...item, hide: this.isCompanyCC, suppressColumnsToolPanel: this.isCompanyCC }
        }
        return item
      })
      if (this.$store.state.uiCustom.enable) {
        result = UICustomUtil.handleColumnLabelAndDisplay(result, this.elementDict, (columnDef, element) => element.customLabel || columnDef.headerName)
      }
      return result
    },
    // 公司CC才隐藏超期利息/应收费用利息字段（TASK#236）
    isCompanyCC() {
      const currentOffice = this.$store.getters.currentOffice
      return !!currentOffice && currentOffice.code === 'CC'
    },
    // 列状态预处理：公司CC时强制隐藏超期利息/应收费用利息（TASK#236）；有显示销售单价hc权限时强制隐藏金额相关列，防止localStorage缓存覆盖
    preColumnStateCallback() {
      const hiddenFields = ['realProfit', 'income', 'cost', 'usdReceivable', 'usdPayable', 'usdProfit', 'vndReceivable', 'vndPayable', 'vndProfit', 'rmbReceivable', 'rmbPayable', 'rmbProfit']
      const alwaysHiddenFields = ['interestAmountCurrency', 'costInterest']
      const isCompanyCC = this.isCompanyCC
      return columnState => {
        if (isCompanyCC) {
          columnState.forEach(state => {
            if (alwaysHiddenFields.includes(state.colId)) {
              state.hide = true
            }
          })
        }
        if (this.showSalePriceHc) {
          columnState.forEach(state => {
            if (hiddenFields.includes(state.colId)) {
              state.hide = true
            }
          })
        }
        return columnState
      }
    },
    colorType() {
      return Number(this.$store.state.settings.colorType) === 1
    },
    colorSettings() {
      return this.$store.state.settings.colorSettings
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
        this.customSearchItems = this.getCustomSearchItems()
        this.applyInterestColumnVisibility()
      }
    },
    defaultSearchItems() {
      this.customSearchItems = this.getCustomSearchItems()
    }
  },
  async created() {
    // 显示销售单价hc权限：复数权限接口对管理员也返回真实配置，配置了该权限才隐藏
    const salePriceHcRes = await getUserPrivileges()
    const salePriceHcList = (salePriceHcRes && salePriceHcRes.data) || []
    this.showSalePriceHc = salePriceHcList.some(p => p.category === 'role' && p.shape === 'show_filed' && p.point === 'price')
    this.isLastCompanyCC = this.isCompanyCC
    await this.preloadBasicData()
    this.initBtn()
    // 动态列拼接
    // 利润
    if (this.$checkPermission(['role_SalesQueryModule_profit'])) {
      this.columnAdds.push({ headerName: this.$t('CargoMsg.Cargo_Profit'), colId: 'realProfit', field: 'realProfit',
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.realProfit2Func(params.value), 2)
        },
        hide: this.showSalePriceHc,
        suppressColumnsToolPanel: this.showSalePriceHc,
        width: 150 })
    }
    // 收入
    if (this.$checkPermission(['role_SalesQueryModule_income'])) {
      this.columnAdds.push({ headerName: this.$t('CargoMsg.Cargo_Revenue'), colId: 'income', field: 'income',
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.realProfit2Func(params.value), 2)
        },
        hide: this.showSalePriceHc,
        suppressColumnsToolPanel: this.showSalePriceHc,
        width: 150 })
    }
    // 支出
    if (this.$checkPermission(['role_SalesQueryModule_expenses'])) {
      this.columnAdds.push({ headerName: this.$t('CargoMsg.Cargo_Expenditure'), colId: 'cost', field: 'cost',
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.realProfit2Func(params.value), 2)
        },
        hide: this.showSalePriceHc,
        suppressColumnsToolPanel: this.showSalePriceHc,
        width: 150 })
    }
    // 应收费用利息（显隐与设置列可见性由finalColumnDefs按公司CC动态注入，见TASK#236）
    this.columnAdds.push({ headerName: '应收费用利息', colId: 'costInterest', field: 'costInterest',
      cellRenderer: (params) => {
        return formatNumberToThousands(ColumnUtils.realProfit2Func(params.value), 2)
      },
      hide: false,
      width: 150 })
    // ========== 新增：业务创建人及币种相关列 ==========
    // 业务创建人
    this.columnAdds.push({
      headerName: this.$t('SeaExport.BusinessCreator'),
      colId: 'createdBy',
      field: 'createdBy',
      cellRenderer: (params) => {
        return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
      },
      hide: true,
      width: 150
    })
    // USD应收
    this.columnAdds.push({
      headerName: this.$t('SeaExport.USD_Receivable'),
      colId: 'usdReceivable',
      field: 'usdReceivable',
      cellRenderer: (params) => {
        if (params.value == null) return ''
        return formatNumberToThousands(params.value, 2)
      },
      hide: this.showSalePriceHc,
      suppressColumnsToolPanel: this.showSalePriceHc,
      width: 150
    })
    // USD应付
    this.columnAdds.push({
      headerName: this.$t('SeaExport.USD_Payable'),
      colId: 'usdPayable',
      field: 'usdPayable',
      cellRenderer: (params) => {
        if (params.value == null) return ''
        return formatNumberToThousands(params.value, 2)
      },
      hide: this.showSalePriceHc,
      suppressColumnsToolPanel: this.showSalePriceHc,
      width: 150
    })
    // USD利润
    this.columnAdds.push({
      headerName: this.$t('SeaExport.USD_Profit'),
      colId: 'usdProfit',
      field: 'usdProfit',
      cellRenderer: (params) => {
        if (params.value == null) return ''
        return formatNumberToThousands(params.value, 2)
      },
      hide: this.showSalePriceHc,
      suppressColumnsToolPanel: this.showSalePriceHc,
      width: 150
    })
    // VND应收
    this.columnAdds.push({
      headerName: this.$t('SeaExport.VND_Receivable'),
      colId: 'vndReceivable',
      field: 'vndReceivable',
      cellRenderer: (params) => {
        if (params.value == null) return ''
        return formatNumberToThousands(params.value, 2)
      },
      hide: this.showSalePriceHc,
      suppressColumnsToolPanel: this.showSalePriceHc,
      width: 150
    })
    // VND应付
    this.columnAdds.push({
      headerName: this.$t('SeaExport.VND_Payable'),
      colId: 'vndPayable',
      field: 'vndPayable',
      cellRenderer: (params) => {
        if (params.value == null) return ''
        return formatNumberToThousands(params.value, 2)
      },
      hide: this.showSalePriceHc,
      suppressColumnsToolPanel: this.showSalePriceHc,
      width: 150
    })
    // VND利润
    this.columnAdds.push({
      headerName: this.$t('SeaExport.VND_Profit'),
      colId: 'vndProfit',
      field: 'vndProfit',
      cellRenderer: (params) => {
        if (params.value == null) return ''
        return formatNumberToThousands(params.value, 2)
      },
      hide: this.showSalePriceHc,
      suppressColumnsToolPanel: this.showSalePriceHc,
      width: 150
    })
    // RMB应收
    this.columnAdds.push({
      headerName: this.$t('SeaExport.RMB_Receivable'),
      colId: 'rmbReceivable',
      field: 'rmbReceivable',
      cellRenderer: (params) => {
        if (params.value == null) return ''
        return formatNumberToThousands(params.value, 2)
      },
      hide: this.showSalePriceHc,
      suppressColumnsToolPanel: this.showSalePriceHc,
      width: 150
    })
    // RMB应付
    this.columnAdds.push({
      headerName: this.$t('SeaExport.RMB_Payable'),
      colId: 'rmbPayable',
      field: 'rmbPayable',
      cellRenderer: (params) => {
        if (params.value == null) return ''
        return formatNumberToThousands(params.value, 2)
      },
      hide: this.showSalePriceHc,
      suppressColumnsToolPanel: this.showSalePriceHc,
      width: 150
    })
    // RMB利润
    this.columnAdds.push({
      headerName: this.$t('SeaExport.RMB_Profit'),
      colId: 'rmbProfit',
      field: 'rmbProfit',
      cellRenderer: (params) => {
        if (params.value == null) return ''
        return formatNumberToThousands(params.value, 2)
      },
      hide: this.showSalePriceHc,
      suppressColumnsToolPanel: this.showSalePriceHc,
      width: 150
    })
    // ========== 新增结束 ==========
    this.loadPageConfig()
    this.customSearchItems = this.getCustomSearchItems()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showBusinessInfo', function() {
      context.showBusinessInfo()
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    loadPageConfig() {
      if (!this.$store.state.uiCustom.enable) {
        return
      }
      const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.SALES_INQUIRY_LIST, this.$store.getters.currentOfficeId)
      this.elementDict = pageConfig.elementDict
      UICustomUtil.handleViewAndWrite(UICustomConstants.SALES_INQUIRY_LIST, this.elementDict)
    },
    getCustomSearchItems() {
      const defaultSearchFields = []
      let searchField = new AdvancedSearchField()
      searchField.itemType = 'company'
      searchField.subType = {
        'type': 'customer',
        'tagValue': 'cmpIdx',
        'useSales': true,
        'useAccountObjectControlMode': false
      }
      searchField.fieldType = 'FIELD_CUSTOMER'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.defaultConditionVal = '='
      searchField.itemName = 'job.CUSTOMER_ID'
      searchField.itemLabel = 'CargoMsg.Cargo_AuthorizedClient'
      searchField.defaultSelected = 1
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      defaultSearchFields.push(searchField.formatObj2Json())

      if (!this.bookingAgentVisible) {
        // 移除订舱代理
        searchField = new AdvancedSearchField()
        searchField.itemType = 'company'
        searchField.subType = {
          'type': 'bookingAgent',
          'tagValue': 'cmpIdx'
        }
        searchField.fieldType = 'FIELD_BOOKING_AGENT'
        searchField.itemName = 'job.BOOKING_AGENT'
        searchField.itemLabel = 'CargoMsg.Cargo_BookingWindow'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 自定义业务类型
      searchField = new AdvancedSearchField()
      searchField.action = this.isSalesForSzfs ? AdvancedSearchField.REMOVE_ACTION : AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'cutomJobType'
      searchField.subType = 'cascader'
      searchField.fieldType = 'FIELD_CUTOM_JOB_TYPE'
      searchField.itemCondition = []
      searchField.defaultConditionVal = '='
      searchField.itemName = 'job.CUSTOM_JOB_TYPE'
      searchField.itemLabel = 'SeaExport.CustomJobType'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.tagValue = 'uuid'
      searchField.tagName = ''
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())

      searchField.itemType = 'date'
      searchField.fieldType = 'FIELD_PAYABLE_CHARGE_LOCKED_DATE'
      searchField.itemCondition = []
      searchField.defaultConditionVal = 'RANGE'
      searchField.itemName = 'job.PAYABLE_CHARGE_LOCKED_DATE'
      searchField.itemLabel = 'CargoMsg.Cargo_PayableFeeLockTime'
      searchField.subType = 'range'
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = []
      defaultSearchFields.push(searchField.formatObj2Json())

      // 运输公司筛选条件
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'company'
      searchField.methodParams = { truckCmp: true, active: true }
      searchField.tagValue = 'cmpIdx'
      searchField.fieldType = 'FIELD_CARRYING_CMP'
      searchField.itemName = 'trucking.CARRYING_CMP'
      searchField.itemLabel = 'CargoMsg.Cargo_TruckingCompany'
      searchField.defaultSelected = 0
      searchField.lock = false
      searchField.multiple = 1 // 支持多选
      defaultSearchFields.push(searchField.formatObj2Json())

      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'user'
      searchField.multiple = 0
      searchField.fieldType = 'FIELD_PAYABLE_CHARGE_LOCK_PERSON'
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.itemName = 'job.PAYABLE_CHARGE_LOCKED_PERSON'
      searchField.itemLabel = 'CargoMsg.Cargo_PayableFeeLockPerson'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = 0
      defaultSearchFields.push(searchField.formatObj2Json())
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'user'
      searchField.fieldType = 'FIELD_USER'
      searchField.subType = {
        category: 'role',
        shape: 'userDefinedRole4'
      }
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.itemName = 'job.user_defined_role_id_4'
      searchField.itemLabel = '海外跟单'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.valueExpression = ''
      searchField.lock = false
      searchField.defaultValue = ''
      defaultSearchFields.push(searchField.formatObj2Json())

      // CARGO-48534 合作伙伴-客户 移除供应商有关字段
      if (this.isSalesForSzfs) {
        // 订/换单窗口
        searchField = new AdvancedSearchField()
        searchField.fieldType = 'FIELD_BOOKING_AGENT'
        searchField.itemName = 'job.BOOKING_AGENT'
        searchField.itemLabel = 'CargoMsg.Cargo_BookingWindow'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
        // CARGO-50706 移除目的港代理
        searchField = new AdvancedSearchField()
        searchField.fieldType = 'FIELD_SEA_DEST_AGENT'
        searchField.itemName = 'job.DESTINATION_AGENT'
        searchField.itemLabel = 'CargoMsg.Cargo_DestinationAgent'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())

        // CARGO-50706 指定货代理
        searchField = new AdvancedSearchField()
        searchField.fieldType = 'FIELD_SEA_DESIGNATION_AGENT'
        searchField.itemName = 'job.DESIGNATION_AGENT'
        searchField.itemLabel = 'CargoMsg.Cargo_NominatedAgent'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      // 销售计提
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.defaultConditionVal = '='
      searchField.itemName = 'provisionHistory.SALES_PROVISION'
      searchField.itemLabel = 'CargoMsg.Cargo_SalesProvision'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.tagValue = ''
      searchField.tagName = ''
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      defaultSearchFields.push(searchField.formatObj2Json())

      // 客服计提
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.defaultConditionVal = '='
      searchField.itemName = 'provisionHistory.CS_PROVISION'
      searchField.itemLabel = 'CargoMsg.Cargo_CustomerServiceProvision'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.tagValue = ''
      searchField.tagName = ''
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      defaultSearchFields.push(searchField.formatObj2Json())

      // 操作计提
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.defaultConditionVal = '='
      searchField.itemName = 'provisionHistory.OP_PROVISION'
      searchField.itemLabel = 'CargoMsg.Cargo_OperationProvision'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.tagValue = ''
      searchField.tagName = ''
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      defaultSearchFields.push(searchField.formatObj2Json())

      // 报关计提
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.defaultConditionVal = '='
      searchField.itemName = 'provisionHistory.CUSTOMS_PROVISION'
      searchField.itemLabel = 'CargoMsg.Cargo_CustomsProvision'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.tagValue = ''
      searchField.tagName = ''
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      defaultSearchFields.push(searchField.formatObj2Json())

      // 商务计提
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.defaultConditionVal = '='
      searchField.itemName = 'provisionHistory.BUSINESS_PROVISION'
      searchField.itemLabel = 'CargoMsg.Cargo_BusinessProvision'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.tagValue = ''
      searchField.tagName = ''
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      defaultSearchFields.push(searchField.formatObj2Json())

      // 销售主管计提
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.defaultConditionVal = '='
      searchField.itemName = 'provisionHistory.SALES_SUPERVISOR_PROVISION'
      searchField.itemLabel = 'CargoMsg.Cargo_SalesSupervisorProvision'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.tagValue = ''
      searchField.tagName = ''
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      defaultSearchFields.push(searchField.formatObj2Json())

      // 操作主管计提
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.itemCondition = [OPERATOR_EQUAL]
      searchField.defaultConditionVal = '='
      searchField.itemName = 'provisionHistory.OP_SUPERVISOR_PROVISION'
      searchField.itemLabel = 'CargoMsg.Cargo_OperationSupervisorProvision'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.tagValue = ''
      searchField.tagName = ''
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      defaultSearchFields.push(searchField.formatObj2Json())

      // 计提日期
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'date'
      searchField.fieldType = 'FIELD_DATE_RANGE'
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.itemName = 'job.provisioned_date'
      searchField.itemLabel = 'CargoMsg.Cargo_AccrualDate'
      searchField.subType = 'range'
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = []
      defaultSearchFields.push(searchField.formatObj2Json())

      if (this.$store.state.uiCustom.enable) {
        UICustomUtil.handleSearchItems(UICustomConstants.SALES_INQUIRY_MODULE, this.defaultSearchItems, defaultSearchFields, UICustomConstants.SALES_INQUIRY_LIST)
      }
      return defaultSearchFields
    },
    // TASK#236 公司CC才隐藏超期利息/应收费用利息查询条件：方案字段由后端全局/个人方案下发，按字段名与标签过滤剔除
    hiddenSearchItemFilter(item) {
      if (!this.isCompanyCC) return false
      if (!item) return false
      if (/interest/i.test(String(item.itemName || ''))) return true
      const rawLabel = String(item.itemLabel || '')
      const label = this.$t(rawLabel)
      return rawLabel === '超期利息' || rawLabel === '应收费用利息' || label === '超期利息' || label === '应收费用利息'
    },
    // TASK#236 公司切换时同步超期利息/应收费用利息列显隐：进入CC隐藏，离开CC恢复默认（超期利息隐藏、应收费用利息显示），CC之间切换不处理
    async applyInterestColumnVisibility() {
      await ensureExecuteSuccess(() => this.gridApi)
      if (!this.gridColumnApi) return
      const wasCompanyCC = this.isLastCompanyCC
      this.isLastCompanyCC = this.isCompanyCC
      if (this.isCompanyCC) {
        this.gridColumnApi.setColumnsVisible(['interestAmountCurrency', 'costInterest'], false)
      } else if (wasCompanyCC) {
        this.gridColumnApi.setColumnsVisible(['interestAmountCurrency'], false)
        this.gridColumnApi.setColumnsVisible(['costInterest'], true)
      }
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    async onGridCellFocused(event) {
      if (!event) return
      this.selectedJob = null
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
        if (this.gridApi && event.column) {
          this.gridApi.forEachNode(node => {
            if (node && node.rowIndex === event.rowIndex && node.data) {
              const nodeJob = node.data
              if (nodeJob.uuid || nodeJob.jobUuid) this.selectedJob = nodeJob
            }
          })
          // this.$logger.log('===onGridCellFocused====', this.selectedJob.jobNo + '_' + this.selectedJob.jobState)
        }
      })
    },
    // 选中 勾选框触发[获取选中行]
    onGridRowSelected(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      if (event.node.isSelected()) {
        const node = event.data
        if (node.uuid || node.jobUuid) this.selectedJob = node
      }
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
      })
      // this.$logger.log('===onGridRowSelected====', this.selectedJob.jobNo + '_' + this.selectedJob.jobState)
      // CARGO-30222 未勾选业务编号时，按现状显示，勾选任意一个或者以上业务编号时，统计展示所有已勾选业务编号的 利润总计以及收入总计
      //             本次不做：不处理分摊费用后 主票仍会统计已经分摊费用的问题
      const rows = this.gridApi.getSelectedRows()
      const masterUuidList = rows.filter(e => e.masterFlag).map(e => e.uuid)
      this.btnInfo.batchSelectFlag = rows.length > 0
      if (rows && rows.length > 0) {
        let realProfit = 0.0
        let realIncome = 0.0
        let costInterest = 0.0
        let cartonQuantity = ''
        let b20Quantity = 0.0
        let b40Quantity = 0.0
        let b40hQuantity = 0.0
        let b45Quantity = 0.0
        let teuQuantity = 0.0
        for (const item of rows) {
          // 只累加 1.主票
          //       2.从属主票未勾选的小票
          //       3.非主小票业务
          if (item.masterFlag || (item.lclMasterUuid && !item.masterFlag && masterUuidList.indexOf(item.lclMasterUuid)) < 0 || (!item.lclMasterUuid && !item.masterFlag)) {
            realProfit += item.realProfit
            realIncome += item.income
            costInterest += item.costInterest || 0
          }
          const boxTypeStatisticsVo = item.boxTypeStatisticsVo
          if (boxTypeStatisticsVo) {
            b20Quantity += boxTypeStatisticsVo.b20
            b40Quantity += boxTypeStatisticsVo.b40
            b40hQuantity += boxTypeStatisticsVo.b40h
            b45Quantity += boxTypeStatisticsVo.b45
            teuQuantity += boxTypeStatisticsVo.teu
          }
        }
        if (b20Quantity > 0) {
          cartonQuantity += b20Quantity + '*' + SeaExportConstants.BOX_TYPE_20.chineseName + ','
        }
        if (b40Quantity > 0) {
          cartonQuantity += b40Quantity + '*' + SeaExportConstants.BOX_TYPE_40.chineseName + ','
        }
        if (b40hQuantity > 0) {
          cartonQuantity += b40hQuantity + '*' + SeaExportConstants.BOX_TYPE_40HQ.chineseName + ','
        }
        if (b45Quantity > 0) {
          cartonQuantity += b45Quantity + '*' + SeaExportConstants.BOX_TYPE_45.chineseName + ','
        }
        if (teuQuantity > 0) {
          cartonQuantity += teuQuantity + this.$t('SeaExport.TEU') + ','
        }
        if (cartonQuantity.length > 0) {
          cartonQuantity = cartonQuantity.substring(0, cartonQuantity.length - 1)
        }
        this.profitTotalText = NumberUtils.ToFixed2(realProfit, 2)
        this.incomeTotalText = NumberUtils.ToFixed2(realIncome, 2)
        this.costInterestTotalText = NumberUtils.ToFixed2(costInterest, 2)
        this.cartonQuantity = cartonQuantity
        this.ticketCount = rows.length
      } else {
        this.profitTotalText = this.initProfitTotalText
        this.incomeTotalText = this.initIncomeTotalText
        this.costInterestTotalText = this.initCostInterestTotalText
        this.cartonQuantity = this.initCartonQuantity
        this.ticketCount = this.initTicketCount
      }
    },
    onGridReady(p) {
      // console.log('gridReady', p)
      this.gridApi = p.api
      this.gridColumnApi = p.columnApi
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      const node = event.data
      if (node.uuid || node.jobUuid) this.selectedJob = node
    },
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
      this.arSettlementUnitOptional = parseInt(cache.config.get('ArSettlementUnitOptional')) === 1
      this.specialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
      this.chargeSchemeBatchDialog.chargeSchemeIsApproved = Number(cache.config.get('ChargeSchemeIsApproved')) === 1 // 费用方案需是否审核后才能使用【费用方案页签使用】
      this.inputIncludingTaxUnitPrice = parseInt(cache.config.get('InputIncludingTaxUnitPrice'))
      this.checkJobTypeHasDiff = parseInt(cache.config.get('checkJobTypeHasDiff')) === 1
      this.showControlledProfit = parseInt(cache.config.get('ShowControlledProfit')) === 1
      this.salesCanSeeBookingAgent = Number(cache.config.get('SalesCanSeeBookingAgent')) === 1
    },
    // 查询[简单查询/高级查询]
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 高级查询
    toAdvancedQuery(data) {
      this.loading = getLoading()
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filter.conditions = this.addConditionsBeforeQuery(data)
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(this.filter.conditions)
        this.filter.pageNum = 1
      }
      const requestBody = {
        appendQuery: this.appendQuery,
        conditions: this.filter.conditions,
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize,
        branchId: this.$store.getters.currentOfficeId
      }
      findJobForSales(requestBody).then(res => this.handleQueryData(res.data)).finally(() => {
        this.loading.close()
      })
    },
    // 查询之前的条件组装
    addConditionsBeforeQuery(data) {
      if (typeof data === 'undefined') {
        return
      }
      const lcOption = AdvancedSearchOption.getOption('job.localSevice', data)
      if (lcOption != null) {
        const codes = lcOption.value
        const services = []
        for (const code of codes) {
          const service = CommonState.getStateByCode(SeaExportConstants.STUFFY_TYPES, code)
          if (service != null) services.push(service)
        }
        const stuffingTypes = this.convertStuffyTypeToQuery(services)
        for (const stuffing in stuffingTypes) {
          data.push(new AdvancedSearchOption(null, stuffingTypes[stuffing], true).formatObj2Json())
        }
      }
      if (AdvancedSearchOption.hasField('job.localSevice', data)) {
        AdvancedSearchOption.removeOption('job.localSevice', data)
      }
      if (AdvancedSearchOption.hasField('job.MBL', data)) {
        const option = AdvancedSearchOption.getOption('job.MBL', data)
        // 正则表达式 ***-**** **** 这样的格式进行处理
        const regex = /^\d{3}-\d{4} \d{4}$/
        // 检查 option.value 是否为数组，如果不是则转为数组处理
        const values = Array.isArray(option.value) ? option.value : [option.value]
        // 处理每个值：对匹配的值去掉空格，不匹配的值保持原样
        const processedValues = values.map(value => {
          if (regex.test(value)) {
            return value.replace(/\s/g, '')
          }
          return value
        })
        // 更新数据
        AdvancedSearchOption.removeOption('job.MBL', data)
        option.value = processedValues.length === 1 ? processedValues[0] : processedValues
        data.push(option)
      }
      // 业务状态
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', data)) {
        const jobStates = Array.from(SystemConstants.JOB_STATES, p => p.code)
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, AdvancedSearchConsts.OPERATOR_IN.code)
        data.push(option.formatObj2Json())
      }
      if (AdvancedSearchOption.hasField('job.CUSTOM_JOB_TYPE', data)) {
        const option = AdvancedSearchOption.removeOption('job.CUSTOM_JOB_TYPE', data)
        option.fieldName = 'job.CUSTOM_JOB_TYPE'
        const customJobType = getObjectByCache(basicCacheKeys.basic_data_CutomJobType, 'uuid', option.value)
        if (customJobType) {
          option.value = [customJobType.type, customJobType.code]
        }
        // 重新加入
        data.push(option)
      }
      JobUtils.handleTrackingInfoMultipleState(data, this.sopStateLob)
      return data
    },
    // 本地服务条件处理
    convertStuffyTypeToQuery(items) {
      const result = []
      for (const stuffyType of items) {
        if (stuffyType.code === 'IS') {
          result.push('job.WAREHOUSING')
        } else if (stuffyType.code === 'DD') {
          result.push('job.LAND_TRANSPORTATION')
        } else if (stuffyType.code === 'SD') {
          result.push('job.SELF_DELIVER')
        } else if (stuffyType.code === 'CT') {
          result.push('seaJob.CUSTOMS')
        } else if (stuffyType.code === 'HT') {
          result.push('seaJob.HEATING')
        } else if (stuffyType.code === 'CIT') {
          result.push('seaJob.COMERCIAL_INSPECTATION')
        } else if (stuffyType.code === 'AMS') {
          result.push('seaJob.AMS')
        } else if (stuffyType.code === 'ISBOOKING') {
          result.push('job.BOOKING')
        }
      }
      return result
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.appendQuery = false // 关闭追加查询
      this.loading = getLoading()
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword.trim()
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      const requestBody = {
        conditions: [new AdvancedSearchOption(null, 'job.JOB_STATE', Array.from(SystemConstants.JOB_STATES, p => p.code), AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json()],
        otherMap: this.filter,
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize,
        branchId: this.$store.getters.currentOfficeId
      }
      findJobForSales(requestBody).then(res => this.handleQueryData(res.data)).finally(() => {
        if (this.$route.params.businessNo && this.rowData.length > 0) {
          this.$nextTick(() => {
            this.$emit('look', this.rowData[0])
          })
          delete this.$route.params.businessNo
        }
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      // 核销状态
      ChargeUtils.calcIsVerification(res)
      let results = Array.isArray(res.results.list)
        ? res.results.list.map(item => this.normalizeChargeLockFields(item))
        : []
      this.filter.pageNum = res.results.pageNum
      this.filter.pageSize = res.results.pageSize
      this.pageCount = res.results.pages
      const total = Number(res.results.total)
      const profitTotal = res.profitTotal || 0.00
      const incomeTotal = res.incomeTotal || 0.00
      const costInterestTotal = res.costInterestTotal || 0.00
      this.chargeStatDialog.currencies = Array.isArray(res.chargeStatCurrencies) ? res.chargeStatCurrencies : []
      this.chargeStatDialog.receivable = res.chargeStatReceivable || {}
      this.chargeStatDialog.due = res.chargeStatDue || {}
      this.chargeStatDialog.total = res.chargeStatTotal || {}
      if (this.appendQuery) { // 追加查询数据去重
        results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
        let realProfit = 0.0
        let income = 0.0
        let costInterest = 0.0
        for (const item of results) {
          if (item.parentUuid) continue
          realProfit += item.realProfit
          income += item.income
          costInterest += item.costInterest || 0
        }
        this.profitTotalText = NumberUtils.ToFixed2(realProfit, 2)
        this.initProfitTotalText = NumberUtils.ToFixed2(realProfit, 2)
        this.incomeTotalText = NumberUtils.ToFixed2(income, 2)
        this.initIncomeTotalText = NumberUtils.ToFixed2(income, 2)
        this.costInterestTotalText = NumberUtils.ToFixed2(costInterest, 2)
        this.initCostInterestTotalText = NumberUtils.ToFixed2(costInterest, 2)
        this.total = results.length
      } else {
        this.profitTotalText = NumberUtils.ToFixed2(profitTotal, 2)
        this.initProfitTotalText = NumberUtils.ToFixed2(profitTotal, 2)
        this.incomeTotalText = NumberUtils.ToFixed2(incomeTotal, 2)
        this.initIncomeTotalText = NumberUtils.ToFixed2(incomeTotal, 2)
        this.costInterestTotalText = NumberUtils.ToFixed2(costInterestTotal, 2)
        this.initCostInterestTotalText = NumberUtils.ToFixed2(costInterestTotal, 2)
        this.total = total
      }
      let cartonQuantity = ''
      let b20Quantity = 0.0
      let b40Quantity = 0.0
      let b40hQuantity = 0.0
      let b45Quantity = 0.0
      let teuQuantity = 0.0
      for (const item of results) {
        const boxTypeStatisticsVo = item.boxTypeStatisticsVo
        if (boxTypeStatisticsVo) {
          b20Quantity += boxTypeStatisticsVo.b20
          b40Quantity += boxTypeStatisticsVo.b40
          b40hQuantity += boxTypeStatisticsVo.b40h
          b45Quantity += boxTypeStatisticsVo.b45
          teuQuantity += boxTypeStatisticsVo.teu
        }
      }
      if (b20Quantity > 0) {
        cartonQuantity += b20Quantity + '*' + SeaExportConstants.BOX_TYPE_20.chineseName + ','
      }
      if (b40Quantity > 0) {
        cartonQuantity += b40Quantity + '*' + SeaExportConstants.BOX_TYPE_40.chineseName + ','
      }
      if (b40hQuantity > 0) {
        cartonQuantity += b40hQuantity + '*' + SeaExportConstants.BOX_TYPE_40HQ.chineseName + ','
      }
      if (b45Quantity > 0) {
        cartonQuantity += b45Quantity + '*' + SeaExportConstants.BOX_TYPE_45.chineseName + ','
      }
      if (teuQuantity > 0) {
        cartonQuantity += teuQuantity + this.$t('SeaExport.TEU') + ','
      }
      if (cartonQuantity.length > 0) {
        cartonQuantity = cartonQuantity.substring(0, cartonQuantity.length - 1)
      }
      this.cartonQuantity = cartonQuantity
      this.initCartonQuantity = cartonQuantity
      this.ticketCount = results.length
      this.initTicketCount = results.length
      this.rowData = results
      this.gridApi.clearFocusedCell()
    },
    normalizeChargeLockFields(item) {
      if (!item) return item
      item.payableChargeLockedDate = item.payableChargeLockedDate || item.payableChargeLockDate || null
      item.payableChargeLockedPerson = item.payableChargeLockedPerson || item.payableChargeLockPerson || item.payableChargeLockedBy || item.payableChargeLockUser || null
      item.receivableChargeLockedDate = item.receivableChargeLockedDate || item.receivableChargeLockDate || null
      return item
    },
    // 查看
    toLook(row) {
      if (!this.$checkPermission(['role_SalesQueryModule_viewJobDetail'])) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckPermission'))
        return
      }
      if (!row) {
        row = this.selectedJob || this.readSelectedRows()[0]
      }
      this.$emit('look', row)
    },
    readSelectedRows() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    // 批量打印（split-button：直点主按钮＝仅打印勾选的第一条；下拉【按业务编号打印】＝对全部勾选业务编号逐单打印）
    onBatchPrint(command) {
      const rows = this.readSelectedRows()
      const payload = buildBatchPrintDialogPayload(rows, command, {
        printByBusinessNumberLabel: this.$t('queryJob.PrintByBusinessNumber'),
        jobTypeDiffCheckEnabled: this.checkJobTypeHasDiff,
        buildCtx: row => new Job(row).fillDefaultValue().getData(),
        // R2 文件历史：下拉分支用空 Job 实体（cloudMetaData.uuid 不落首单），
        // printSource 开后端 uploadFileHistory 逐单记录闸门（参照页 bookingTreeGrid 同款参数）
        buildEmptyCtx: () => new Job().fillDefaultValue().getData(),
        printSourceByLob: {
          SE: BATCH_PRINT_SE.code,
          SI: BATCH_PRINT_SI.code,
          AE: BATCH_PRINT_AE.code,
          AI: BATCH_PRINT_AI.code,
          RE: BATCH_PRINT_RE.code,
          RI: BATCH_PRINT_RE.code, // 铁路进口归 RE（对齐 cargoTemplateSelectorDialog 批量分支 RE/RI 合并语义）
          IE: BATCH_PRINT_IE.code
        },
        defaultPrintSource: BATCH_PRINT_SE.code // 未知 lob 保底开闸（销售查询弹窗 category 固定 SALETYPE）
      })
      if (payload.blocked === 'JOB_TYPE_DIFF') {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckBusinessType'))
        return
      }
      if (payload.blocked === 'NO_SELECTION') return
      this.jobUuidList = payload.jobUuidList
      this.templateSelectorDialog.ctx = payload.ctx
      this.templateSelectorDialog.category = payload.category
      this.templateSelectorDialog.data = payload.data
      this.templateSelectorDialog.visible = true
    },
    // 初始化 按钮 相关信息
    initBtn() {
      const addChargeTypeRadios = []
      const editChargeTypeRadios = []
      const delChargeTypeRadios = []
      const importChargeTypeRadios = []

      if (this.$checkPermission(['button_SalesQueryModule_AddEditCostCharge', 'button_SalesQueryModule_AddEditPayCharge']) ||
        (this.specialExpenseEntryFunction && this.$checkPermission(['button_SalesQueryModule_AddEditCostSpecialCharge', 'button_SalesQueryModule_AddEditPaySpecialCharge']))) {
        // 按钮下拉
        this.operateMultiJobChargeBtns.push(this.$t('SeaExport.AddCharges'))
        this.operateMultiJobChargeBtns.push(this.$t('SeaExport.EditCharges'))
        // 是否展示按钮
        this.showOperateMultiJobChargeBtn = true
        // 当前按钮
        this.chargeCommand = this.$t('SeaExport.AddCharges')

        if (this.$checkPermission(['button_SalesQueryModule_AddEditCostCharge'])) {
          addChargeTypeRadios.push({ label: SystemConstants.CHARGE_TYPE_RADIO_COST.code, name: this.$t('CargoMsg.Cargo_Receivable') })
          editChargeTypeRadios.push({ label: SystemConstants.CHARGE_TYPE_RADIO_COST.code, name: this.$t('CargoMsg.Cargo_Receivable') })
        }
        if (this.$checkPermission(['button_SalesQueryModule_AddEditPayCharge'])) {
          addChargeTypeRadios.push({ label: SystemConstants.CHARGE_TYPE_RADIO_PAY.code, name: this.$t('CargoMsg.Cargo_Dues') })
          editChargeTypeRadios.push({ label: SystemConstants.CHARGE_TYPE_RADIO_PAY.code, name: this.$t('CargoMsg.Cargo_Dues') })
        }
        if (this.$checkPermission(['button_SalesQueryModule_AddEditCostCharge']) && this.$checkPermission(['button_SalesQueryModule_AddEditPayCharge'])) {
          addChargeTypeRadios.push({ label: SystemConstants.CHARGE_TYPE_RADIO_COST_PAY.code, name: this.$t('CargoMsg.Cargo_ARAP') })
          editChargeTypeRadios.push({ label: SystemConstants.CHARGE_TYPE_RADIO_COST_PAY.code, name: this.$t('CargoMsg.Cargo_ARAP') })
        }

        if (this.specialExpenseEntryFunction) {
          if (this.$checkPermission(['button_SalesQueryModule_AddEditCostSpecialCharge'])) {
            addChargeTypeRadios.push({
              label: SystemConstants.CHARGE_TYPE_RADIO_COST_SPECIAL.code,
              name: this.$t('CargoMsg.Cargo_ReceivableSpecialFee')
            })
            editChargeTypeRadios.push({
              label: SystemConstants.CHARGE_TYPE_RADIO_COST_SPECIAL.code,
              name: this.$t('CargoMsg.Cargo_ReceivableSpecialFee')
            })
          }
          if (this.$checkPermission(['button_SalesQueryModule_AddEditPaySpecialCharge'])) {
            addChargeTypeRadios.push({
              label: SystemConstants.CHARGE_TYPE_RADIO_PAY_SPECIAL.code,
              name: this.$t('CargoMsg.Cargo_PayableSpecialFee')
            })
            editChargeTypeRadios.push({
              label: SystemConstants.CHARGE_TYPE_RADIO_PAY_SPECIAL.code,
              name: this.$t('CargoMsg.Cargo_PayableSpecialFee')
            })
          }
          if (this.$checkPermission(['button_SalesQueryModule_AddEditCostSpecialCharge']) && this.$checkPermission(['button_SalesQueryModule_AddEditPaySpecialCharge'])) {
            // 新增特殊费用 咱无批量操作，不需要 应收应付特殊费用 操作
            // 编辑特殊费用
            editChargeTypeRadios.push({
              label: SystemConstants.CHARGE_TYPE_RADIO_COST_PAY_SPECIAL.code,
              name: this.$t('CargoMsg.Cargo_ReceivablePayableSpecialFee')
            })
          }
        }
      }
      if (this.$checkPermission(['button_SalesQueryModule_DelCostCharge', 'button_SalesQueryModule_DelPayCharge'])) {
        this.operateMultiJobChargeBtns.push(this.$t('SeaExport.DeleteCharges'))
        if (!this.showOperateMultiJobChargeBtn) {
          this.showOperateMultiJobChargeBtn = true
          this.chargeCommand = this.$t('SeaExport.DeleteCharges')
        }

        if (this.$checkPermission(['button_SalesQueryModule_DelCostCharge'])) {
          delChargeTypeRadios.push({ label: SystemConstants.CHARGE_TYPE_RADIO_COST.code, name: this.$t('CargoMsg.Cargo_Receivable') })
        }
        if (this.$checkPermission(['button_SalesQueryModule_DelPayCharge'])) {
          delChargeTypeRadios.push({ label: SystemConstants.CHARGE_TYPE_RADIO_PAY.code, name: this.$t('CargoMsg.Cargo_Dues') })
        }
        if (this.$checkPermission(['button_SalesQueryModule_DelCostCharge']) && this.$checkPermission(['button_SalesQueryModule_DelPayCharge'])) {
          delChargeTypeRadios.push({ label: SystemConstants.CHARGE_TYPE_RADIO_COST_PAY.code, name: this.$t('CargoMsg.Cargo_ARAP') })
        }
      }
      if (this.$checkPermission(['button_SalesQueryModule_ImportCostCharge', 'button_SalesQueryModule_ImportPayCharge'])) {
        this.operateMultiJobChargeBtns.push(this.$t('SeaExport.ChargeImport'))
        if (!this.showOperateMultiJobChargeBtn) {
          this.showOperateMultiJobChargeBtn = true
          this.chargeCommand = this.$t('SeaExport.ChargeImport')
        }

        if (this.$checkPermission(['button_SalesQueryModule_ImportCostCharge'])) {
          importChargeTypeRadios.push({ label: SystemConstants.CHARGE_TYPE_RADIO_COST.code, name: this.$t('CargoMsg.Cargo_Receivable') })
        }
        if (this.$checkPermission(['button_SalesQueryModule_ImportPayCharge'])) {
          importChargeTypeRadios.push({ label: SystemConstants.CHARGE_TYPE_RADIO_PAY.code, name: this.$t('CargoMsg.Cargo_Dues') })
        }
        if (this.$checkPermission(['button_SalesQueryModule_ImportCostCharge']) && this.$checkPermission(['button_SalesQueryModule_ImportPayCharge'])) {
          importChargeTypeRadios.push({ label: SystemConstants.CHARGE_TYPE_RADIO_COST_PAY.code, name: this.$t('CargoMsg.Cargo_ARAP') })
        }
      }

      this.chargeTypes[this.$t('SeaExport.AddCharges')] = addChargeTypeRadios
      this.chargeTypes[this.$t('SeaExport.EditCharges')] = editChargeTypeRadios
      this.chargeTypes[this.$t('SeaExport.DeleteCharges')] = delChargeTypeRadios
      this.chargeTypes[this.$t('SeaExport.ChargeImport')] = importChargeTypeRadios
    },
    // 批量处理费用
    chargeHandle() {
      if (this.hierarchyViewList) {
        const rows = this.readSelectedRows()
        this.checkOwnerBranch(rows)
      }

      // 校验 业务类型、FBA 状态是否一致
      const rows = this.readSelectedRows()
      const baseJobNo = rows[0].jobNo
      const baseLob = rows[0].lob
      const baseFba = Boolean(rows[0].fba)
      let row = null
      for (const item of rows) {
        if (item.lob !== baseLob) {
          row = item
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectSameBusinessTypeWithJobNo', { baseJobNo, currentJobNo: row.jobNo }))
          return
        }
        if (Boolean(item.fba) !== baseFba) {
          row = item
          this.$message.warning(this.$t('CargoMsg.Cargo_SelectSameFbaStatusWithJobNo', { baseJobNo, currentJobNo: row.jobNo }))
          return
        }
      }

      // 正操作 校验
      row = rows.find(p => p.jobState !== SystemConstants.OPERATING)
      if (row) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectBusinessOperation'))
        return
      }

      // 业务锁定状态 费用不可操作（因为空出有，应该所有都要限制）
      for (const obj of rows) {
        if (JobUtils.isBlockJob(obj)) {
          this.$message.warning(this.$t('Message.TheSelectedServicesIncludeLockedServices'))
          return
        }
      }

      // 委托单位一致校验
      if (this.arSettlementUnitOptional && [this.$t('SeaExport.ChargeImport')].indexOf(this.chargeCommand) > -1) {
        row = rows.find(p => p.customerId !== rows[0].customerId)
        if (row) {
          this.$message.warning(this.$t('CargoMsg.Cargo_BatchOperationSameEntrustedUnit'))
          return
        }
      }

      this.chargeTypeDialog.data = this.chargeTypes[this.chargeCommand]
      // this.chargeTypeDialog.type = this.chargeTypeDialog.data[0].label
      this.chargeTypeDialog.type = -1
      switch (this.chargeCommand) {
        case this.$t('SeaExport.AddCharges'):
          this.toAddCharge()
          break
        case this.$t('SeaExport.EditCharges'):
          this.toEditCharge()
          break
        case this.$t('SeaExport.DeleteCharges'):
          this.toDeleteCharge()
          break
        case this.$t('SeaExport.ChargeImport'):
          this.toImportCharge()
          break
      }
    },
    // 新增费用
    async toAddCharge() {
      this.chargeTypeDialog.title = this.$t('CargoMsg.Cargo_AddCostType')
      this.chargeTypeDialog.visible = true
    },
    // 编辑费用
    async toEditCharge() {
      this.chargeTypeDialog.title = this.$t('CargoMsg.Cargo_EditFeeType')
      this.chargeTypeDialog.visible = true
    },
    // 删除费用
    async toDeleteCharge() {
      this.chargeTypeDialog.title = this.$t('CargoMsg.Cargo_DeleteFeeType')
      this.chargeTypeDialog.visible = true
    },
    // 批量导入费用
    async toImportCharge() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length > 500) {
        this.$message.info(this.$t('Message.TheNumberOfSelectedDataLimited') + 500)
        return
      }

      const row = rows.find(p => p.containerLoadType !== rows[0].containerLoadType)
      if (row) {
        this.$message.info(this.$t('Message.TheSelectedDocumentInconsistentNatureOfTheContainerLoadType'))
        return
      }

      this.chargeTypeDialog.title = this.$t('CargoMsg.Cargo_ImportFeeType')
      this.chargeTypeDialog.visible = true
    },
    onChargeTypeDialogConfirm() {
      if (this.chargeTypeDialog.type === -1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectFeeType'))
        return
      }
      this.chargeTypeDialog.visible = false
      // 应收是否锁定
      const type = this.chargeTypeDialog.type
      const rows = this.gridApi.getSelectedRows()
      if (!rows || rows.length === 0) return
      if ([SystemConstants.CHARGE_TYPE_RADIO_COST_PAY.code, SystemConstants.CHARGE_TYPE_RADIO_COST_PAY_SPECIAL.code].indexOf(type) > -1) {
        const chargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0 && p.payableChargeLockedStatus > 0)
        if (chargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ReceivablePayableLocked'))
          return
        }
        const receivableChargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0)
        if (receivableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ReceivableLocked'))
          return
        }
        const payableChargeLocked = rows.find(p => p.payableChargeLockedStatus > 0)
        if (payableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PayableLocked'))
          return
        }
      } else if ([SystemConstants.CHARGE_TYPE_RADIO_COST.code, SystemConstants.CHARGE_TYPE_RADIO_COST_SPECIAL.code].indexOf(type) > -1) {
        const receivableChargeLocked = rows.find(p => p.receivableChargeLockedStatus > 0)
        if (receivableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ReceivableLocked'))
          return
        }
      } else if ([SystemConstants.CHARGE_TYPE_RADIO_PAY.code, SystemConstants.CHARGE_TYPE_RADIO_PAY_SPECIAL.code].indexOf(type) > -1) {
        const payableChargeLocked = rows.find(p => p.payableChargeLockedStatus > 0)
        if (payableChargeLocked) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PayableLocked'))
          return
        }
      }

      switch (this.chargeCommand) {
        case this.$t('SeaExport.AddCharges'):
          this.addCharge(type)
          break
        case this.$t('SeaExport.EditCharges'):
          this.editCharge(type)
          break
        case this.$t('SeaExport.DeleteCharges'):
          this.deleteCharge(type)
          break
        case this.$t('SeaExport.ChargeImport'):
          this.importCharge(type)
          break
      }
    },
    async addCharge(chargeType) {
      if ([SystemConstants.CHARGE_TYPE_RADIO_COST_PAY.code, SystemConstants.CHARGE_TYPE_RADIO_COST.code,
        SystemConstants.CHARGE_TYPE_RADIO_PAY.code].indexOf(chargeType) > -1) {
        if (!JobUtils.checkJobCustomerIdIfSame(this.arSettlementUnitOptional, chargeType, this.gridApi.getSelectedRows(), this)) {
          return
        }
        this.addChargeDetailDialog.selectedJobs = this.gridApi.getSelectedRows()
        this.addChargeDetailDialog.chargeType = chargeType
        this.addChargeDetailDialog.selectedScheme = []
        this.addChargeDetailDialog.visible = true
      } else if ([SystemConstants.CHARGE_TYPE_RADIO_COST_PAY_SPECIAL.code, SystemConstants.CHARGE_TYPE_RADIO_COST_SPECIAL.code,
        SystemConstants.CHARGE_TYPE_RADIO_PAY_SPECIAL.code].indexOf(chargeType) > -1) {
        // 校验 业务是否归档
        const rows = this.gridApi.getSelectedRows()
        const row = rows.find(p => !!p.pigeonhole)
        if (row) {
          this.$message.warning(this.$t('CargoMsg.NOT_OPERATIONAL'))
          return
        }
        const charge = new Charge().fillDefaultValue().getData()
        charge.specialInputDate = DateUtils.formatStandardDateTime(new Date())
        // 录入日期
        charge.dateCreated = DateUtils.formatStandardDateTime(new Date())
        // BUG-0013 费用所属分公司：从订单上下文取（行数据的操作公司），不再读跨会话 localStorage 记忆
        charge.branchId = resolveSalesSpecialChargeBranchId(rows[0], this.$store.getters.currentOfficeId)
        const localCurrency = await RateUtil.localCurrencyByOfficeIdSync(charge.branchId)
        charge.localCurrency = localCurrency
        charge.currency = localCurrency
        // 国内/国外
        if (LocalStorageUtils.hasConfiguration('specialChangeoversea') && LocalStorageUtils.getConfiguration('specialChangeoversea') !== null) {
          charge.oversea = Boolean(LocalStorageUtils.getConfiguration('specialChangeoversea'))
        }
        charge.unitPriceIncludeTax = this.inputIncludingTaxUnitPrice === 2
        this.specialChargeWindow.defaultProperties.editMode = 'add'
        this.specialChargeWindow.defaultProperties.isAr = (SystemConstants.CHARGE_TYPE_RADIO_COST_SPECIAL.code === chargeType)
        this.specialChargeWindow.defaultProperties.job = rows[0]
        this.specialChargeWindow.defaultProperties.selectedJobs = rows
        this.specialChargeWindow.defaultProperties.charge = charge
        this.specialChargeWindow.visible = true
      }
    },
    editCharge(chargeType) {
      if ([SystemConstants.CHARGE_TYPE_RADIO_COST_PAY.code, SystemConstants.CHARGE_TYPE_RADIO_COST.code,
        SystemConstants.CHARGE_TYPE_RADIO_PAY.code].indexOf(chargeType) > -1) {
        this.editChargeDetailDialog.modifySpecialCharge = false
      } else if ([SystemConstants.CHARGE_TYPE_RADIO_COST_PAY_SPECIAL.code, SystemConstants.CHARGE_TYPE_RADIO_COST_SPECIAL.code,
        SystemConstants.CHARGE_TYPE_RADIO_PAY_SPECIAL.code].indexOf(chargeType) > -1) {
        this.editChargeDetailDialog.modifySpecialCharge = true
      }
      this.editChargeDetailDialog.selectedJobs = this.gridApi.getSelectedRows()
      this.editChargeDetailDialog.chargeType = chargeType
      this.editChargeDetailDialog.visible = true
    },
    deleteCharge(chargeType) {
      this.deleteChargeDetailDialog.selectedJobs = this.gridApi.getSelectedRows()
      this.deleteChargeDetailDialog.chargeType = chargeType
      this.deleteChargeDetailDialog.visible = true
    },
    // 批量导入费用
    async importCharge(chargeType) {
      const selectedJobs = this.gridApi.getSelectedRows()
      // 将相同的委托单位、订舱代理、承运人、整拼类型、货物类型、起运港、目的港、目的港代理带入到费用方案窗口
      let isSameCustomer = true
      let isSameBookingAgent = true
      let isSameCarrierId = true
      let isSameContainerLoadType = true
      let isSameCargoType = true
      let isSameLoadingPort = true
      let isSameDestinationPort = true
      let isSameDestinationAgent = true
      let isSameVesselLine = true
      const containerLoadType = selectedJobs[0].containerLoadType
      const customerId = selectedJobs[0].customerId
      const bookingAgent = selectedJobs[0].bookingAgent
      const carrierId = selectedJobs[0].carrierId
      const cargoType = selectedJobs[0].cargoType
      const loadingPort = selectedJobs[0].loadingPortCode
      const destinationPort = selectedJobs[0].destinationPortCode
      const destinationAgent = selectedJobs[0].destinationAgent
      let vesselLine = ''
      const port = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', selectedJobs[0].dischargingPortCode)
      if (port) {
        vesselLine = port.region
      }
      for (const seaJob of selectedJobs) {
        if (customerId !== seaJob.customerId) {
          isSameCustomer = false
        }
        if (bookingAgent !== seaJob.bookingAgent) {
          isSameBookingAgent = false
        }
        if (carrierId !== seaJob.carrierId) {
          isSameCarrierId = false
        }
        if (containerLoadType !== seaJob.containerLoadType) {
          isSameContainerLoadType = false
        }
        if (cargoType !== seaJob.cargoType) {
          isSameCargoType = false
        }
        if (loadingPort !== seaJob.loadingPortCode) {
          isSameLoadingPort = false
        }
        if (destinationPort !== seaJob.destinationPortCode) {
          isSameDestinationPort = false
        }
        if (destinationAgent !== seaJob.destinationAgent) {
          isSameDestinationAgent = false
        }
        const seaPort = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', seaJob.dischargingPortCode)
        if (vesselLine !== (seaPort ? seaPort.region : '')) {
          isSameVesselLine = false
        }
      }
      const sameCondition = {}
      if (isSameCustomer) {
        sameCondition['customerId'] = customerId
      }
      if (isSameBookingAgent) {
        sameCondition['bookingAgent'] = bookingAgent
      }
      if (isSameCarrierId) {
        sameCondition['carrierId'] = carrierId
      }
      if (isSameContainerLoadType) {
        sameCondition['containerLoadType'] = containerLoadType
      }
      if (isSameCargoType) {
        sameCondition['cargoType'] = cargoType
      }
      if (isSameLoadingPort) {
        sameCondition['loadingPort'] = loadingPort
      }
      if (isSameDestinationPort) {
        sameCondition['destinationPort'] = destinationPort
      }
      if (isSameDestinationAgent) {
        sameCondition['destinationAgent'] = destinationAgent
      }
      if (isSameVesselLine) {
        sameCondition['vesselLine'] = vesselLine
      }
      this.chargeSchemeBatchDialog.source = this.addChargeDetailDialog.visible ? 'addCharge' : 'jobList'
      this.chargeSchemeBatchDialog.selectedJobs = selectedJobs
      this.chargeSchemeBatchDialog.chargeType = chargeType
      this.chargeSchemeBatchDialog.isSea = ['SE', 'SI', 'IE'].indexOf(selectedJobs[0].lob) > -1
      this.chargeSchemeBatchDialog.lob = selectedJobs[0].lob
      this.chargeSchemeBatchDialog.job = selectedJobs[0]
      this.chargeSchemeBatchDialog.needCheckRange = !(selectedJobs.length > 1) // 勾选了多票业务就不要用单个业务数据区间过滤费用方案
      this.chargeSchemeBatchDialog.originalCondition = sameCondition
      this.chargeSchemeBatchDialog.visible = true
    },
    // 统计
    async statistics_clickHandler() {
      this.statisticsClean()
      const loading = getLoading4Cxt(this)
      try {
        await this.handleStatistics()
        this.statisticsDialog.visible = true
      } finally {
        loading.close()
      }
    },
    async handleStatistics(isChangeContainShutOutJob = false) {
      let rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        rows = this.rowData
      }
      if (rows.length === 0) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      const jobKeys = []
      const designationAgents = []
      const customers = []
      let weight = 0
      let chargeWeight = 0
      let cubage = 0
      let slavesCount = 0
      let masterCount = 0
      let count = 0
      let lob = ''
      // 列表勾选的数据是否都为”已退关“
      let allJobShutOut = true
      for (const job of rows) {
        if (job.jobState !== SystemConstants.STATE_SHUT_OUT.code) {
          allJobShutOut = false
          break
        }
      }
      for (const job of rows) {
        if (job.jobState === SystemConstants.STATE_SHUT_OUT.code) {
          // 弹窗手动修改”是否包含退关“
          if (isChangeContainShutOutJob && !this.statisticsDialog.containShutOutJob) {
            continue
          } else if (!isChangeContainShutOutJob && !allJobShutOut) { // 第一次打开弹窗
            continue
          }
        }
        count++
        if (lob === '') lob = job.lob
        jobKeys.push(job.uuid)
        if (job.masterFlag) {
          masterCount += 1
        } else {
          weight += isNaN(job.weightActual) ? 0 : job.weightActual
          cubage += isNaN(job.cubageActual) ? 0 : job.cubageActual
          chargeWeight += isNaN(job.chargeWeight) ? 0 : job.chargeWeight
          slavesCount += 1
        }
        if (!customers.includes(job.customerId) && !job.masterFlag) {
          customers.push(job.customerId)
        }
        if (!designationAgents.includes(job.designationAgent) && job.designationAgent !== 0) {
          designationAgents.push(job.designationAgent)
        }
      }
      this.statisticsDialog.txtSlaves = slavesCount.toString()
      this.statisticsDialog.txtMaster = masterCount.toString()
      this.statisticsDialog.txtCount = count.toString()
      this.statisticsDialog.txtCustomerCount = customers.length.toString()
      this.statisticsDialog.txtWeight = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(weight), 3)
      this.statisticsDialog.txtCubage = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(cubage), 3)
      this.statisticsDialog.txtChargeWeight = formatNumberToThousands(ColumnUtils.returnThreeZeroFormatNumber(chargeWeight), 3)
      this.statisticsDialog.txtdesignationAgentNum = designationAgents.length.toString()
      if (!isChangeContainShutOutJob && allJobShutOut) {
        this.statisticsDialog.containShutOutJob = true
      }
      statisticsJobs({ jobKeys: jobKeys, lob: 'all', containShutOutJob: this.statisticsDialog.containShutOutJob }).then(res => this.statisticsJobsResult(res.data))
    },
    // 统计结果
    statisticsJobsResult(res) {
      if (!res) return
      this.statisticsDialog.txt20 = res.b20
      this.statisticsDialog.txt40 = res.b40
      this.statisticsDialog.txt40hq = res.b40h
      this.statisticsDialog.txt45 = res.b45
      this.statisticsDialog.txtTeu = res.teu
    },
    // 统计完成 清空对象
    statisticsClean() {
      if (!this.statisticsDialog) return
      for (const key in this.statisticsDialog) {
        this.statisticsDialog[key] = ''
      }
      this.statisticsDialog.containShutOutJob = false
    },
    // 列表 业务编号旁边搜索框的打印
    showBusinessInfo(e) {
      stopBubble(e)
      // TemplateSelectorWin.getInstance().showThisWin(data as AbstractEntity, "JOB_DETAIL_OP", {"JOB_UUID":data.key}, FlexGlobals.topLevelApplication as DisplayObject);
      if (!this.selectedJob) return
      this.templateSelectorDialog.ctx = new SeaExportJob(this.selectedJob)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedJob.uuid }
      this.templateSelectorDialog.visible = true
    },
    // 选中父级自动勾选子集，取消选中类似
    treeDataRowSelectedCallBack(p) {
      // return
      if (p.data.root) {
        if (p.node.selected) {
          p.node.childrenAfterGroup.forEach((node) => {
            node.setSelected(p.node.selected)
          })
        } else {
          const isTrue = p.node.childrenAfterGroup.filter(
            (node) => node.selected
          )
          if (isTrue.length === p.node.childrenAfterGroup.length) {
            p.node.childrenAfterGroup.forEach((node) => {
              node.setSelected(p.node.selected)
            })
          }
        }
      } else {
        if (!p.node.selected) {
          if (p.node.parent.selected) {
            p.node.parent.setSelected(false)
          }
        } else {
          const brothers = p.node.parent.childrenAfterGroup
          const selected = brothers.filter((node) => node.selected)
          if (selected.length === brothers.length) {
            p.node.parent.setSelected(true)
          }
        }
      }
    },
    // 查询条件选择状态追踪的时候，触发回调事件
    sopStateChange(data) {
      if (data) {
        this.sopStateLob = data
      }
    },
    // 批量操作
    batchHandle(val) {
      switch (val) {
        case 1:
          JobUtils.toBatchFillGpExplain(this.readSelectedRows(), this.gpExplain)
          break
        case 2:
          this.toBatchModifyChargeLockStatus(false)
          break
        case 3:
          this.toBatchModifyChargeLockingStatus(false)
          break
      }
    },
    // 发起费用解锁申请（订单状态需已审核）
    toUnlockApply() {
      const rows = this.readSelectedRows()
      for (const item of rows) {
        if (item.jobState !== SystemConstants.VERIFIED) {
          this.$message.warning(this.$t('SeaExport.UnlockApplyJobStateInvalid'))
          return
        }
      }
      if (rows.length > 200) {
        this.$message.warning(this.$t('SeaExport.UnlockApplyOverLimit'))
        return
      }
      this.unlockApplyDialog.selectedJobs = [...rows]
      this.unlockApplyDialog.visible = true
    },
    // 批量解锁应付费用
    async toBatchModifyChargeLockStatus(receivable) {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!await SecurityUtil.canEdit(new Job(item))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          return
        }
        if (receivable) {
          if (item.receivableChargeLockedStatus !== 1) {
            this.$message.warning(this.$t('Message.BatchUnlockLockedBillsOfAccountsReceivable'))
            return
          }
        } else if (item.payableChargeLockedStatus !== 1) {
          this.$message.warning(this.$t('Message.BatchUnlockLockedBillsOfAccountsPayable'))
          return
        }
        jobKeys.push(item.uuid)
      }
      if (jobKeys.length > 0) {
        const t = receivable ? this.$t('Message.Receivable') : this.$t('Message.Payable')
        this.$confirm(this.$t('Message.UnlockChargeStatus', [t]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading()
          batchModifyChargeLockStatus({ uuids: jobKeys, receivable: receivable, lockStatus: 0 }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('Message.SuccessfullyUnlockedFeesInBatch', [t, res.data]))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    // 批量锁定应付费用
    async toBatchModifyChargeLockingStatus(receivable) {
      const rows = this.readSelectedRows()
      const jobKeys = []
      for (const item of rows) {
        if (this.isCooperate(item.cooperateStatus)) {
          this.$message.warning('[' + item.jobNo + ']' + this.$t('CargoMsg.Cargo_IsCooperate'))
          return
        }
        if (!await SecurityUtil.canEdit(new Job(item))) {
          this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
          return
        }
        if (receivable) {
          if (item.receivableChargeLockedStatus !== 0) {
            this.$message.warning(this.$t('Message.BatchUnlockLockingBillsOfAccountsReceivable'))
            return
          }
        } else if (item.payableChargeLockedStatus !== 0) {
          this.$message.warning(this.$t('Message.BatchUnlockLockingBillsOfAccountsPayable'))
          return
        }
        jobKeys.push(item.uuid)
      }
      if (jobKeys.length > 0) {
        const t = receivable ? this.$t('Message.Receivable') : this.$t('Message.Payable')
        this.$confirm(this.$t('Message.LockingChargeStatus', [t]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.loading = getLoading()
          batchModifyChargeLockStatus({ uuids: jobKeys, receivable: receivable, lockStatus: 1 }).then(res => {
            this.loading.close()
            if (res.data) {
              this.$message.success(this.$t('Message.SuccessfullylockingedFeesInBatch', [t, res.data]))
              this.toQuery()
            }
          }).finally(() => {
            this.loading.close()
          })
        })
      }
    },
    validMultipleSelect() {
      if (this.hqViewAllList) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        for (const row of this.readSelectedRows()) {
          if (!this.isZy && this.hierarchyViewDetail && row) {
            if (this.childOfficeIds.includes(row.opOffice) || this.childOfficeIds.includes(row.salesOffice)) {
              return true
            }
          }
          if (row.opOffice !== this.$store.getters.currentOfficeId && row.salesOffice !== this.$store.getters.currentOfficeId && !this.matchCooperateBranch(row.cooperatebranch, this.$store.getters.currentOffice)) {
            return false
          }
        }
      }
      return true
    },
    toChangeSchema() {
      if ([SystemConstants.CHARGE_TYPE_RADIO_COST_PAY.code, SystemConstants.CHARGE_TYPE_RADIO_COST.code,
        SystemConstants.CHARGE_TYPE_RADIO_PAY.code].indexOf(this.chargeTypeDialog.type) > -1) {
        // 先打开费用方案弹框，选择方案后再带入到新增费用弹框
        this.importCharge(this.chargeTypeDialog.type)
      }
    },
    // 处理费用方案选择
    handleSelectedScheme(selectedScheme) {
      // 关闭费用方案弹框
      this.chargeSchemeBatchDialog.visible = false
      // 打开新增费用弹框，并带入选择的费用方案
      this.addChargeDetailDialog.selectedJobs = this.gridApi.getSelectedRows()
      this.addChargeDetailDialog.chargeType = this.chargeTypeDialog.type
      this.addChargeDetailDialog.selectedScheme = selectedScheme
      this.addChargeDetailDialog.visible = true
    },
    openChargeStatDialog() {
      this.chargeStatDialog.visible = true
    },
    // 是否协作业务
    isCooperate(cooperateStatus) {
      if (cooperateStatus !== -1 && this.useOrderCenterMode) {
        return true
      }
      return false
    },
    formatStatAmount(value) {
      if (value === null || typeof value === 'undefined' || value === '') return '0.00'
      const numberValue = Number(value)
      if (Number.isNaN(numberValue)) return value
      return formatNumberToThousands(numberValue, 2)
    }
  }
}
</script>

<style lang="scss">
.amount-sum{
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.amount-sum-left{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.amount-sum-right{
  flex: 0 0 auto;
}
.charge-stat-table{
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}
.charge-stat-row{
  display: flex;
}
.charge-stat-row + .charge-stat-row{
  border-top: 1px solid #ebeef5;
}
.charge-stat-row:nth-child(even){
  background: #f7f9fc;
}
.charge-stat-cell{
  flex: 1 1 0;
  padding: 8px 12px;
  text-align: center;
  border-right: 1px solid #ebeef5;
}
.charge-stat-cell:last-child{
  border-right: 0;
}
.charge-stat-cell.label{
  text-align: left;
  font-weight: 600;
  color: #303133;
}
.charge-stat-head{
  background: #f2f4f8;
  font-weight: 600;
  color: #606266;
}
.charge-stat-empty{
  text-align: center;
  color: #909399;
  padding: 24px 0;
}
.amount-sum-btn{
  margin-left: 0;
  padding: 0;
  text-decoration: underline;
}
.charge-stat-dialog{
  position: fixed;
  right: 16px;
  bottom: 56px;
  margin: 0;
}
.charge-stat-dialog .el-dialog__header{
  padding-right: 36px;
}
</style>
